<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-lg-12">
				<div class="d-flex flex-wrap flex-wrap align-items-center justify-content-center mb-3">
					<div class="text-center">
						<h4 class="mb-3">{{ title }}</h4>
						<p class="mb-0">{{ desc1 }}<br> {{ desc2 }}<br>{{ desc3 }}</p>
					</div>
				</div>
			</div>
			<div class="col-lg-12">
				<div class="d-flex justify-content-center h-100">
					<input ref="cursor" type="text" class="form-control w-25 h-100 text-center rounded-pill"
						placeholder="키워드 추가 (콤마로 구분하여 여러개 입력 가능)" v-model="targetKeyword" @keyup.enter="addKeyword($event)"
						@change="keyinkeywords">
				</div>
			</div>
			<div class="col-lg-12 d-flex justify-content-center align-items-center" v-if="showspinner">
				<div class="custom-control custom-control-inline d-flex justify-content-center">
					<div class="row">
						<div class="col-12">
							<img style="max-width:50px;" :src="require('../../../assets/images/small/loading.gif')">
							<span>{{ loadingtext }}... {{ loadingrate }}</span>
						</div>
					</div>
				</div>
			</div>
			<div class="col-lg-12 d-flex flex-wrap justify-content-center align-items-center border-top border-left border-right border-bottom" v-if="showKeywordGroupUI">
				<b-badge variant="primary text-center">키워드 수집</b-badge>
				<div class="ml-3 pl-2 border-left">
					<button type="button" class="btn btn-outline-primary ml-2" v-b-modal.relKeyword>연관+자동완성</button>
					<button type="button" class="btn btn-outline-primary ml-2" v-b-modal.keywordRank>네이버데이터랩</button>
					<button type="button" class="btn btn-outline-primary ml-2" v-b-modal.excelupload>대량업로드</button>
				</div>
				<div class="ml-3 pl-3 border-left d-flex align-items-center">
					<b-dropdown id="keyword-group-dropdown" :text="'키워드그룹: ' + activeKeywordGroup" class="mr-2" variant="outline-success">
						<b-dropdown-item v-for="groupName in Object.keys(keywordGroups)" :key="groupName"
										:active="groupName === activeKeywordGroup"
										@click="switchKeywordGroup(groupName)">
							<div class="d-flex justify-content-between align-items-center">
								<div>{{ groupName }}</div>
								<b-badge variant="secondary" v-if="groupName !== 'Default'" @click.stop="deleteKeywordGroup(groupName)">Del</b-badge>
							</div>
						</b-dropdown-item>
						<b-dropdown-divider v-if="Object.keys(keywordGroups).length > 0"></b-dropdown-divider>
						<b-dropdown-item @click="createKeywordGroup">새 키워드그룹</b-dropdown-item>
					</b-dropdown>
					<b-button variant="outline-danger" @click="clearCurrentKeywords">
						현재 키워드 초기화
					</b-button>
				</div>
			</div>


			<div class="col-lg-12 d-flex flex-wrap justify-content-center align-items-center border-left border-right border-bottom"
				v-if="this.keywords.length > 0">
				<b-badge variant="success text-center">데이터 수집</b-badge>
				<div class="ml-3 pl-3 border-left" style="font-size:80%">
					<div class="mb-1 d-flex align-items-center">
						<span class="mr-2">수집모드</span>
						<div class="btn-group btn-group-sm" role="group" aria-label="수집 모드">
							<button type="button" class="btn"
								:class="collectMode === 'fast' ? 'btn-primary' : 'btn-outline-secondary'"
								@click="collectMode = 'fast'; checkShowItems()">빠른수집</button>
							<button type="button" class="btn"
								:class="collectMode === 'pageRange' ? 'btn-primary' : 'btn-outline-secondary'"
								@click="collectMode = 'pageRange'; checkShowItems()">페이지별</button>
						</div>
					</div>
					<div>
						<div class="custom-control custom-checkbox custom-checkbox-color-check custom-control-inline">
							<input type="checkbox" class="custom-control-input bg-primary" id="customCheck-1"
								v-model="check1" @change="checkShowItems">
							<label class="custom-control-label" for="customCheck-1"> 쿠팡월검색량, 검색트렌드, 쿠팡키워드CPC</label>
						</div>
					</div>
					<div>
						<div class="custom-control custom-checkbox custom-checkbox-color-check custom-control-inline">
							<input type="checkbox" class="custom-control-input bg-primary" id="customCheck-2"
								v-model="check2" @change="checkShowItems">
							<label class="custom-control-label" for="customCheck-2"> 상세 키워드분석</label>
						</div>
					</div>
					<!-- <div>
						<div class="custom-control custom-checkbox custom-checkbox-color-check custom-control-inline">
							<input type="checkbox" class="custom-control-input bg-primary" id="customCheck-4"
								v-model="check3" @change="checkShowItems">
							<label class="custom-control-label" for="customCheck-4"> 쿠팡1점리뷰비율(반품율), 쿠팡중간매출, 쿠팡평균매출
							</label>
						</div>
					</div> -->



					<!-- <div class="custom-control custom-checkbox custom-checkbox-color-check custom-control-inline">
						<input type="checkbox" class="custom-control-input bg-primary" id="customCheck-14" v-model="showNaverAvgSales" disabled>
						<label class="custom-control-label" for="customCheck-14"> 네이버평균매출</label>
					</div> -->
				</div>
				<div class="ml-3 pl-3 border-left">
					<button type="button" class="btn btn-outline-primary" @click="search">키워드 데이터 수집시작</button>
					<button type="button" class="btn btn-outline-secondary ml-2" @click="deleteKeywords">삭제</button>
					<button type="button" class="btn btn-outline-success ml-2" @click="downloadKeywords">다운로드</button>
					<button type="button" class="btn btn-outline-info ml-2" @click="addToSourcingBoard">소싱관리 담기</button>
				</div>
			</div>


			<b-modal :id="'relKeyword'" size="xl" title="쿠팡 연관+자동완성 키워드 수집" ok-title="수집하기" cancel-title="취소"
				@ok="collectRelKeyword">
				<div class="row">
					<div class="col-md-12 d-flex justify-content-center">
						<input ref="cursor" type="text" class="form-control text-center rounded-pill"
							placeholder="검색키워드" v-model="targetKeyword" @keyup.enter="collectRelKeywordEnter($event)">
					</div>
					<div class="col-md-12 d-flex align-items-center justify-content-start">
						<div class="custom-control custom-checkbox custom-checkbox-color-check custom-control-inline">
							<input type="checkbox" class="custom-control-input bg-primary" id="customCheck-18"
								v-model="relKeywordChecked">
							<label class="custom-control-label" for="customCheck-18"> 연관키워드</label>
						</div>
						<div class="custom-control custom-checkbox custom-checkbox-color-check custom-control-inline">
							<input type="checkbox" class="custom-control-input bg-primary" id="customCheck-17"
								v-model="autoCompleteChecked">
							<label class="custom-control-label" for="customCheck-17"> 자동완성키워드</label>
						</div>
						<div class="ml-4">
							반복횟수
						</div>
						<div class="custom-control-inline ml-3 d-flex justify-content-start">
							<input type="number" :min="1" :max="500" class="form-control text-center" placeholder=""
								aria-label="" v-model="relCycle">
						</div>
					</div>
				</div>
			</b-modal>

			<b-modal :id="'keywordRank'" size="xl" title="네이버 데이터랩 키워드 수집" ok-title="수집하기" cancel-title="취소"
				@ok="collectKeyword">
				<div class="row">
					<div class="col-md-12 mt-2 d-flex align-items-center justify-content-between">
						<div style="font-size:85%"><b>[수집할 키워드 순위설정]</b><br>새탭에 네이버 데이터랩 쇼핑인사이트<br>Top500키워드가 나오도록 먼저
							세팅해주세요</div>
						<div class="custom-control-inline ml-3 d-flex justify-content-center">
							<input type="number" :min="1" :max="500" class="form-control" placeholder="" aria-label=""
								v-model="startRank" style="text-align:center;">
							~
							<input type="number" :min="1" :max="500" class="form-control" placeholder="" aria-label=""
								v-model="endRank" style="text-align:center;">
						</div>
					</div>
				</div>
			</b-modal>

			<b-modal size="xl" id="excelupload" scrollable title="키워드대량업로드" ok-only>
				<div class="row">
					<div class="col-md-12">
						<!-- <p><b style="color:red">1688을 통해 구매하지 않거나, 별도 재고로 관리하는 사입제품의 경우, 구매링크를 '사입'이라고 표시해 주세요</b></p>
                        <p>신규상품, 발주상태 등 상품 내역에 변경사항이 있을 경우 서플라이어에 접속한 후 <u v-b-modal.modal-3>크롬확장프로그램</u>으로 SKU 리스트를 먼저 수집해 주세요</p> -->
						<p>[업로드 방법]</p>
						<p>1. 엑셀업로드 포맷 다운로드<br>
							2. 엑셀 파일에서 키워드 부분(맨윗줄 제외) 업데이트<br>
							3. 업데이트된 엑셀 파일 업로드 순으로 진행해 주세요.</p>

					</div>
					<div class="col-md-12 mt-4">
						<div class="form-group">
							<label>1. 엑셀업로드 포맷</label>
							<div>
								<button type="reset" @click="formatDownload"
									class="btn btn-primary mr-2">Download</button>
							</div>
						</div>
					</div>
					<div class="col-md-12">
						<div class="form-group">
							<label for="Code">2. 업데이트된 구매요청양식 업로드</label>
							<div class="custom-file">
								<input ref="pdbupload" type="file" @change="uploadfile" class="custom-file-input"
									id="inputGroupFile02">
								<label class="custom-file-label" for="inputGroupFile02">{{ uploadstatus }}</label>
							</div>
							<div class="col-md-12" v-if="showuploadspinner">
								<div>
									<img style="width:5%;" :src="require('../../../assets/images/small/loading.gif')">
								</div>
							</div>
						</div>
					</div>
				</div>
			</b-modal>



			<!-- 옛 확장이라 네이버 추세 칸이 비면 조용히 두지 않고 크게 알린다(D-153 · cpl-x3-naverkeyaes-1) -->
			<div class="col-lg-12 mt-4" v-if="trendExtNotice">
				<div class="alert alert-danger d-flex align-items-center flex-wrap mb-0">
					<strong class="mr-2">{{ trendExtNotice }}</strong>
					<button type="button" class="btn btn-sm btn-outline-dark" @click="trendExtNotice = ''">닫기</button>
				</div>
			</div>
			<div class="col-lg-12 mt-4" v-if="metricsFailNotice">
				<div class="alert alert-warning d-flex align-items-center flex-wrap mb-0">
					<span class="mr-2">{{ metricsFailNotice }}</span>
					<button type="button" class="btn btn-sm btn-outline-dark" @click="metricsFailNotice = ''; search()">다시 가져오기</button>
				</div>
			</div>
			<div class="col-lg-12 mt-4" v-if="collectFailNotice">
				<div class="alert alert-warning d-flex align-items-center flex-wrap mb-0">
					<span class="mr-2">{{ collectFailNotice }}</span>
					<button type="button" class="btn btn-sm btn-outline-dark" @click="collectFailNotice = ''">닫기</button>
				</div>
			</div>
			<div class="col-lg-12 mt-4" v-if="salesZeroNotice">
				<div class="alert alert-info d-flex align-items-center flex-wrap mb-0">
					<span class="mr-2">{{ salesZeroNotice }}</span>
					<button type="button" class="btn btn-sm btn-outline-dark" @click="salesZeroNotice = ''">닫기</button>
				</div>
			</div>
			<div class="col-lg-12 mt-4" v-if="showlist">
				<CDataTable
					storage-key="keywordCollect" :headers="headers" :items="keywords" v-model="tableSelectedItem" :show-select="true"
					itemKey="keyword" nulls-last style="margin-bottom: 10px">
					<template v-slot:add="{ item }">
						<div v-if="!item.add">
							<button type="button" class="btn btn-outline-primary ml-2"
							@click="addRelKeyword(item)">+</button>
						</div>
					</template>
					<template v-slot:del="{ item }">
						<button type="button" class="btn btn-outline-secondary ml-2"
							@click="deleteKeyword(item)">x</button>
					</template>
					<template v-slot:검색트렌드지난달="{ item }">
						{{ typeof item.검색트렌드지난달 === 'number' ? item.검색트렌드지난달.toLocaleString() : (item.검색트렌드지난달 || 0) }}
					</template>
					<template v-slot:키워드트렌드지난달네이버="{ item }">
						{{ typeof item.키워드트렌드지난달네이버 === 'number' ? item.키워드트렌드지난달네이버.toLocaleString() : (item.키워드트렌드지난달네이버 || 0) }}
					</template>
					<template v-for="header in slotHeaders" v-bind:slot="header.value" slot-scope="{ item }">
						{{ typeof item[header.value] === 'number' ? item[header.value]?.toLocaleString() :
							(item[header.value] === null && item.실패칸 && item.실패칸[header.value]) ? item.실패칸[header.value] :
							(item[header.value] === null && (['쿠팡중간매출', '쿠팡평균매출'].includes(header.value) || ['카테고리명', '카테고리적합도'].includes(header.value) || /^(평균|중간|최대|최소)(월조회수|월판매량|월매출|전환율)$/.test(header.value))) ? '모름' :
							(item[header.value] === null && ['쿠팡중간판매가', '쿠팡평균판매가', '쿠팡판매가범위'].includes(header.value)) ? '판매가 없음' :
							item[header.value] }}
					</template>
				</CDataTable>
			</div>

		</div>
	</div>
</template>
<script>
import axios from 'axios';
import * as XLSX from 'xlsx';
import CDataTable from "@/components/common/CDataTable";
import IndexedDBStore from '@/components/common/IndexedDB';
import { datalabTrendNotice } from '@/utils/datalabTrendNotice';

// import { chrome } from 'vue-chrome-extension';
export default {
	name: 'rank',
	data() {
		return {
			rateLimitAlerted: false,
			reviewOffAlerted: false,
			headers: [
				{ text: '키워드', value: 'keyword', align: 'center', width: 150, isSlot: false },
				// {text: '구매관리', value: '구매정보', align: 'center', width: 100, isSlot: true},
				// {text: '판매링크', value: '판매링크', align: 'center', width: 100, isSlot: true},
				// {text: '아이템위너', value: '아이템위너', align: 'center', width: 100, isSlot: true},
				// {text: '뱃지', value: '뱃지', align: 'center', width: 100, isSlot: true},
				// {text: '사이즈', value: '사이즈', align: 'center', width: 100, isSlot: true},
				// {text: '판매가', value: '판매가', align: 'center', width: 100, isSlot: true},
				// {text: '할인쿠폰', value: '할인쿠폰', align: 'center', width: 100, isSlot: true},
				// {text: '수수료', value: '수수료', align: 'center', width: 100, isSlot: true},
				// {text: '매입가', value: '매입가', align: 'center', width: 100, isSlot: true},
				// {text: '마진', value: '마진', align: 'center', width: 100, isSlot: true},
				// {text: '마진율\nROI\nEnd ROAS', value: '마진율', align: 'center', width: 100, isSlot: true},
				{ text: '연관\n자동완성', value: 'add', align: 'center', width: 50, isSlot: true },
				{ text: '삭제', value: 'del', align: 'center', width: 50, isSlot: true },
			],
			// headers: [
			//     {text: '키워드', value: 'keyword', align: 'center', width: 500, isSlot: true},
			//     {text: '구매관리', value: '구매정보', align: 'center', width: 100, isSlot: true},
			//     {text: '판매링크', value: '판매링크', align: 'center', width: 100, isSlot: true},
			//     {text: '아이템위너', value: '아이템위너', align: 'center', width: 100, isSlot: true},
			//     {text: '뱃지', value: '뱃지', align: 'center', width: 100, isSlot: true},
			//     {text: '사이즈', value: '사이즈', align: 'center', width: 100, isSlot: true},
			//     {text: '판매가', value: '판매가', align: 'center', width: 100, isSlot: true},
			//     {text: '할인쿠폰', value: '할인쿠폰', align: 'center', width: 100, isSlot: true},
			//     {text: '수수료', value: '수수료', align: 'center', width: 100, isSlot: true},
			//     {text: '매입가', value: '매입가', align: 'center', width: 100, isSlot: true},
			//     {text: '마진', value: '마진', align: 'center', width: 100, isSlot: true},
			//     {text: '마진율\nROI\nEnd ROAS', value: '마진율', align: 'center', width: 100, isSlot: true},
			//     // {text: 'Actions', value: '', align: 'center', width: 100, isSlot: true},
			// ],
			tableSelectedItem: [],
			keywords: [],
			db: null,

			showuploadspinner: false,
			uploadstatus: 'excel file upload',

			check1: true,
			check2: false,
			check3: false,

			collectMode: 'fast', // 빠른수집(pre-matching) / 페이지별(www SRP)

			showCoupangMonthlySearch: true,
			showCoupangMedianPrice: false,
			showCoupangPriceRange: false,
			showCoupangOneStarRate: false,
			showOptimalCategory: false,
			showCoupangAvgPrice: false,
			showCoupangMedianSales: false,
			showCoupangAvgSales: false,
			// showCoupangMedianViews: false,
			showCoupangAvgViews: false,
			showCoupangRecCPC: false,
			showCoupangTopGrowthRate: false,
			showCoupangTopRocketRate: false,
			showCoupangTopWingRate: false,
			// showNaverAvgSales: false,
			showSearchTrend: false,

			relKeywordChecked: true,
			autoCompleteChecked: true,

			relCycle: 1,
			// showDataCollect:false,
			related: false,
			auth: '',
			loadingtext: '연관검색어 수집 중',
			loadingrate: '',

			showspinner: false,
			showlist: false,
			metricsFailNotice: '',
			trendExtNotice: '',
			collectFailNotice: '',
			salesZeroNotice: '',

			waitresult: false,
			targetKeyword: '',
			fullsearch: false,
			addlines: 10,
			rowlines: [],

			title: "키워드 수집",
			desc1: "키워드 수집방법과 데이터 수집방법을 선택한 후 수집합니다.",
			desc3: "",
			startRank: 1,
			endRank: 500,

			// 키워드 그룹 관련
			keywordGroups: {},
			activeKeywordGroup: 'Default',
			showKeywordGroupUI: true,
		}
	},
	components: {
		CDataTable,
	},
	// watch: {
	// keywords: {
	// 	handler(newKeywords) {
	// 		// IndexedDB에 저장
	// 		// if (this.db) {
	// 		// 	this.db.saveKeywords(newKeywords).catch(error => {
	// 		// 		console.error('키워드 저장 실패:', error);
	// 		// 	});
	// 		// }
	// 	},
	// 	deep: true
	// }
	// },
	async created() {
		// IndexedDB 초기화 - 기존 keywords 스토어 사용 (기존 데이터 유지)
		this.db = new IndexedDBStore();
		await this.db.initDB();

		// 키워드 그룹 불러오기
		try {
			const savedKeywordGroups = await this.db.getKeywordGroups();
			if (savedKeywordGroups && Object.keys(savedKeywordGroups).length > 0) {
				this.keywordGroups = savedKeywordGroups;
			} else {
				// 기본 그룹 생성
				this.keywordGroups = { 'Default': [] };
				await this.db.saveKeywordGroups(this.keywordGroups);
			}
		} catch (error) {
			console.error('키워드 그룹 불러오기 실패:', error);
			this.keywordGroups = { 'Default': [] };
		}

		// 저장된 키워드 불러오기 (현재 활성 그룹의 키워드)
		try {
			console.log('loadKeywordsFromGroup 호출됨, 활성 그룹:', this.activeKeywordGroup);
			console.log('keywordGroups 데이터:', this.keywordGroups);

			if (this.keywordGroups[this.activeKeywordGroup]) {
				const validKeywords = this.keywordGroups[this.activeKeywordGroup].filter(item => {
					return item && typeof item.keyword === 'string' && item.keyword.trim().length > 0;
				});

				console.log('불러온 키워드 개수:', validKeywords.length);
				if (validKeywords.length > 0) {
					console.log('첫 번째 불러온 키워드:', validKeywords[0]);
				}

				this.keywords = validKeywords;

				// Vue의 반응성을 위해 nextTick 사용
				this.$nextTick(() => {
					this.updateHeaders();
					this.showlist = true;
				});
			}
		} catch (error) {
			console.error('키워드 불러오기 실패:', error);
		}
	},

	beforeDestroy() {
		window.removeEventListener('message', this.messageEventHandler);
	},
	mounted() {
		this.messageEventHandler = async (event) => {
			if (event.data.res && event.data.res === 'login') {
				alert('쿠팡wing에 로그인 해주세요')
				this.showspinner = false;
				// this.showlist = false;
				return
			}
			if (event.data.res && event.data.res === 'alert') {
				alert(event.data.alert)
				// 알림 뒤 결과가 안 오는 길(탭 없음·CLI 꺼짐)에서 스피너가 계속 돌았다
				this.showspinner = false;
				return
			}
			if (event.data.res && event.data.res === 'collectKeyword') {
				if (event.data.error) {
					alert(event.data.error)
					this.showspinner = false;
					return
				}
				if (event.data.keywords && event.data.keywords.length > 0) {
					// this.showlist=false;
					var allKeywords = event.data.keywords;
					for (var keyword of allKeywords) {
						if (keyword.replaceAll(" ", "").length > 0) {
							if (!this.keywords.find(e => e.keyword.replaceAll(" ", "") == keyword.replaceAll(" ", ""))) {
								this.keywords.push({
									keyword: keyword.replaceAll(" ", ""),
									add: false,
									del: false,
								})
							}
						}
					}
				}
				// 키워드를 전부 push한 뒤, 그룹에 저장
				await this.saveCurrentGroup();

				this.$nextTick(() => {
					this.showlist = true;
					this.showspinner = false;
				});
				return
			}
			if (event.data.res && event.data.res === 'datalabKeywordStatus') {
				console.log(event.data.status);
				this.loadingtext = event.data.text;
				this.loadingrate = '(' + (event.data.status * 100).toFixed(0) + "%)";
				this.showspinner = true;
			}
			if (event.data.res && event.data.res === 'keywordanalysisstatus') {
				console.log(event.data.status);
				this.loadingtext = '키워드 별 페이지 분석 중';
				this.loadingrate = '(' + (event.data.status * 100).toFixed(0) + "%)";
				this.showspinner = true;
			}
			if (event.data.res && event.data.res === 'keywordanalysisstatusratio') {
				console.log(event.data.status);
				this.showspinner = true;
				this.loadingtext = event.data.text;
				this.loadingrate = '(' + (event.data.status * 100).toFixed(0) + "%)";
				return
			}
			// if(event.data.res && event.data.res === 'keywordanalysis'){
			// 	if(!event.data.cpc){
			// 		alert('CPC단가는 쿠팡wing에 로그인 후 정상적으로 출력됩니다.')
			// 	}
			//     console.log(event.data.coupang);
			// 	console.log(event.data.naver);
			// 	console.log(event.data.cpc);

			// 	this.loadingtext = '데이터 계산 중';
			// 	this.loadingrate = "";
			// 	this.showspinner = true;
			// 	this.showlist = false;
			// 	this.makerowlines(event.data.coupang,event.data.naver,event.data.cpc);
			// 	// var obj = event.data.result;
			// 	// this.rowlines[obj.index].rank = obj.rank;
			// 	// this.rowlines[obj.index].adqty = obj.adqty;
			// 	// this.rowlines[obj.index].adplace = obj.adplace;
			// 	// this.rowlines[obj.index].productqty = obj.productqty;
			// 	// this.rowlines[obj.index].rocketqty = obj.rocketqty;
			// 	// this.rowlines[obj.index].totalrank = obj.totalrank;
			// 	// this.waitresult = false;
			// 	// await this.sleep(10);
			// 	// this.showspinner = false;
			// 	// this.showlist = true;
			// }
			if (event.data.res && event.data.res === 'adkeywords') {
				// this.showlist=false;
				allKeywords = event.data.relatedkeywords;
				console.log(allKeywords)
				for (keyword of allKeywords) {
					console.log(keyword, keyword.replaceAll(" ", ""), !this.keywords.find(e => e.keyword.replaceAll(" ", "") == keyword.replaceAll(" ", "")))
					if (!this.keywords.find(e => e.keyword.replaceAll(" ", "") == keyword.replaceAll(" ", ""))) {
						if (keyword.replaceAll(" ", "").length > 0) {
							this.keywords.push({
								keyword: keyword.replaceAll(" ", ""),
								add: false,
								del: false,
							})
						}
					}
				}
				await this.saveCurrentGroup();
				this.$nextTick(() => {
					this.showlist = true;
					this.showspinner = false;
				})
			}
			if (event.data.res && event.data.res === 'collectKeywordData') {
				this.showlist = false;
				console.log(event.data)
				var keywordVolume = event.data.keywordVolume;
				var keywordCPC = event.data.keywordCPC;
				var keywordTrend = event.data.keywordTrend;
				this.trendExtNotice = datalabTrendNotice({ hasDatalabKey: !!this.$store.state.settings?.[0]?.hasDatalabKey, trendVia: event.data.trendVia, keywordTrend });
				// 광고센터 로그인 풀림 등으로 못 가져온 항목 — 0·빈칸으로 «완료» 처럼 그리지 않고 «—» + 안내 띠
				var metricsFailed = event.data.metricsFailed;
				var failedItems = (metricsFailed && Array.isArray(metricsFailed.items)) ? metricsFailed.items : [];
				this.metricsFailNotice = failedItems.length
					? `광고센터 로그인이 풀려 ${failedItems.join('·')} 를 못 가져왔어요. 잠시 뒤 다시 가져오기를 눌러 주세요.`
					: '';

				if (keywordVolume) {
					if (!this.headers.find(f => f.value == '검색트렌드지난달')) {
						this.headers.splice(-1, 0, { text: '검색트렌드\n지난달', value: '검색트렌드지난달', align: 'center', width: 100, isSlot: true });
					}

					for (var e of keywordVolume) {
						const found = this.keywords.find(
							f => f.keyword.replaceAll(" ", "") == e.keyword.replaceAll(" ", "")
						);
						if (found) {
							found.검색트렌드지난달 = e?.searchVolume?.EXACT ? e.searchVolume.EXACT : 0;
						}
					}
				}
				if (failedItems.includes('검색량')) {
					if (!this.headers.find(f => f.value == '검색트렌드지난달')) {
						this.headers.splice(-1, 0, { text: '검색트렌드\n지난달', value: '검색트렌드지난달', align: 'center', width: 100, isSlot: true });
					}
					for (const k of this.keywords) if (typeof k.검색트렌드지난달 !== 'number' || !k.검색트렌드지난달) k.검색트렌드지난달 = '—';
				}
				if (keywordTrend) {
					if (!this.headers.find(f => f.value == '검색트렌드이번달')) {
						this.headers.splice(-1, 0, { text: '검색트렌드\n이번달', value: '검색트렌드이번달', align: 'center', width: 100, isSlot: true });
					}
					if (!this.headers.find(f => f.value == '검색트렌드+3개월')) {
						this.headers.splice(-1, 0, { text: '검색트렌드\n+3개월', value: '검색트렌드+3개월', align: 'center', width: 100, isSlot: true });
					}
					if (!this.headers.find(f => f.value == '검색트렌드+6개월')) {
						this.headers.splice(-1, 0, { text: '검색트렌드\n+6개월', value: '검색트렌드+6개월', align: 'center', width: 100, isSlot: true });
					}
					for (e of keywordTrend) {
						var monthlySearch = this.keywords.find(f => f.keyword.replaceAll(" ", "") == e.title.replaceAll(" ", "")).검색트렌드지난달;
						var predictResult = await this.predictFutureSearchVolumes(monthlySearch, e.data)
						console.log(predictResult)
						this.keywords.find(f => f.keyword.replaceAll(" ", "") == e.title.replaceAll(" ", ""))["검색트렌드이번달"] = Math.round(predictResult?.oneMonthLaterVolume) ? Math.round(predictResult.oneMonthLaterVolume) : 0;
						this.keywords.find(f => f.keyword.replaceAll(" ", "") == e.title.replaceAll(" ", ""))["검색트렌드+3개월"] = Math.round(predictResult?.threeMonthsLaterVolume) ? Math.round(predictResult.threeMonthsLaterVolume) : 0;
						this.keywords.find(f => f.keyword.replaceAll(" ", "") == e.title.replaceAll(" ", ""))["검색트렌드+6개월"] = Math.round(predictResult?.sixMonthsLaterVolume) ? Math.round(predictResult.sixMonthsLaterVolume) : 0;
					}
				}
				if (keywordCPC) {
					if (!this.headers.find(f => f.value == '쿠팡키워드CPC')) {
						this.headers.splice(-1, 0, { text: '쿠팡\n키워드CPC', value: '쿠팡키워드CPC', align: 'center', width: 100, isSlot: true });
					}
					for (e of Object.keys(keywordCPC)) {
						this.keywords.find(f => f.keyword.replaceAll(" ", "") == e.replaceAll(" ", "")).쿠팡키워드CPC = keywordCPC[e]?.suggested ? keywordCPC[e].suggested : 0;
					}
				}
				if (failedItems.includes('CPC')) {
					if (!this.headers.find(f => f.value == '쿠팡키워드CPC')) {
						this.headers.splice(-1, 0, { text: '쿠팡\n키워드CPC', value: '쿠팡키워드CPC', align: 'center', width: 100, isSlot: true });
					}
					for (const k of this.keywords) if (typeof k.쿠팡키워드CPC !== 'number' || !k.쿠팡키워드CPC) k.쿠팡키워드CPC = '—';
				}
				await this.saveCurrentGroup();
				this.$nextTick(() => {
					this.showlist = true;
					this.showspinner = false;
				})
			}
			if (event.data.res && event.data.res === 'keywordCollectFailSummary') {
				// 그 윙 계정의 쿠팡 판매량 조회가 막힘(의심 포함) — 잠시 후 다시가 아니라 다른 윙 계정으로
				if (event.data.blocked) {
					alert(event.data.message || '이 윙 계정은 쿠팡 판매량 조회가 제한돼 있어요 — 다른 윙 계정으로 로그인해 다시 조회해 주세요');
				} else if (event.data.paused) {
					// 쿠플러스 CLI 가 쿠팡 거절이 잇따라 쉬는 중 — 계정 막힘이 아니다(계정 전환 안내 0) · 남은 분(모르면 «모름»)
					const left = event.data.retryAfterMin ? `약 ${event.data.retryAfterMin}분` : '잠시(남은 시간 모름)';
					alert(`${event.data.total}개 중 ${event.data.failedCount}개 수집을 못 했어요. 쿠팡 거절이 잇따라 쿠플러스가 쿠팡 윙 조회를 ${left} 쉬고 있어요. 「실패」로 표시된 키워드는 그 뒤 다시 수집해 주세요.`);
				} else if (event.data.failedCount > 0) {
					alert(event.data.total + '개 중 ' + event.data.failedCount + '개 수집에 실패했습니다. 「실패」로 표시된 키워드는 잠시 후 다시 수집해 주세요.');
				}
				return
			}
			if (event.data.res && event.data.res === 'topProducts') {
				this.showlist = false;
				console.log(event.data)
				if (this.showCoupangMedianPrice) {
					if (!this.headers.find(f => f.value == '쿠팡중간판매가')) {
						this.headers.splice(-1, 0, { text: '쿠팡\n중간판매가', value: '쿠팡중간판매가', align: 'center', width: 100, isSlot: true });
					}
				}
				if (this.showCoupangPriceRange) {
					if (!this.headers.find(f => f.value == '쿠팡판매가범위')) {
						this.headers.splice(-1, 0, { text: '쿠팡판매가\n범위(25~75%)', value: '쿠팡판매가범위', align: 'center', width: 100, isSlot: true });
					}
				}
				if (this.showCoupangAvgPrice) {
					if (!this.headers.find(f => f.value == '쿠팡평균판매가')) {
						this.headers.splice(-1, 0, { text: '쿠팡\n평균판매가', value: '쿠팡평균판매가', align: 'center', width: 100, isSlot: true });
					}
				}
				if (this.showCoupangTopGrowthRate) {
					if (!this.headers.find(f => f.value == '상위그로스비율')) {
						this.headers.splice(-1, 0, { text: '상위\n그로스비율', value: '상위그로스비율', align: 'center', width: 100, isSlot: true });
					}
				} else {
					const idxGrowth = this.headers.findIndex(f => f.value == '상위그로스비율');
					if (idxGrowth !== -1) this.headers.splice(idxGrowth, 1);
				}
				if (this.showCoupangTopRocketRate) {
					if (!this.headers.find(f => f.value == '상위로켓비율')) {
						this.headers.splice(-1, 0, { text: '상위\n로켓비율', value: '상위로켓비율', align: 'center', width: 100, isSlot: true });
					}
				} else {
					const idxRocket = this.headers.findIndex(f => f.value == '상위로켓비율');
					if (idxRocket !== -1) this.headers.splice(idxRocket, 1);
				}
				if (this.showCoupangTopWingRate) {
					if (!this.headers.find(f => f.value == '상위윙비율')) {
						this.headers.splice(-1, 0, { text: '상위\n윙비율', value: '상위윙비율', align: 'center', width: 100, isSlot: true });
					}
				} else {
					const idxWing = this.headers.findIndex(f => f.value == '상위윙비율');
					if (idxWing !== -1) this.headers.splice(idxWing, 1);
				}
				if (this.showOptimalCategory) {
					if (!this.headers.find(f => f.value == '카테고리명')) {
						this.headers.splice(-1, 0, { text: '카테고리명', value: '카테고리명', align: 'center', width: 200, isSlot: true });
						this.headers.splice(-1, 0, { text: '카테고리\n적합도', value: '카테고리적합도', align: 'center', width: 100, isSlot: true });
					}
				}
				if (this.showCoupangAvgViews) {
					const avgViewsColumns = [
						'평균월조회수', '중간월조회수', '최대월조회수', '최소월조회수',
						'평균월판매량', '중간월판매량', '최대월판매량', '최소월판매량',
						'평균월매출', '중간월매출', '최대월매출', '최소월매출',
						'평균전환율', '중간전환율', '최대전환율', '최소전환율'
					];

					avgViewsColumns.forEach(columnName => {
						if (!this.headers.find(f => f.value == columnName)) {
							this.headers.splice(-1, 0, { text: columnName, value: columnName, align: 'center', width: 100, isSlot: true });
						}
					});
				}

				var topProducts = event.data.topProducts;
				keyword = event.data.keyword;
				var keywordCategory = event.data.keywordCategory;
				console.log(topProducts)
				if (topProducts) {
					if (this.keywords.find(f => f.keyword.replaceAll(" ", "") == keyword.replaceAll(" ", ""))) {
						const targetKeyword = this.keywords.find(f => f.keyword.replaceAll(" ", "") == keyword.replaceAll(" ", ""));
						// 실패 표시는 따로 칸(실패칸: 칸 이름 → 글)에 — 숫자 칸에 글을 넣으면 소싱관리 보드 정렬이 글 비교로 깨진다
						// 숫자 칸은 숫자 아니면 null · 표·엑셀은 실패칸을 보고 「실패」 그대로 보여 준다
						const failCells = targetKeyword ? { ...(targetKeyword.실패칸 || {}) } : {};
						delete failCells.쿠팡중간판매가;
						// 확장이 재수집까지 했는데도 실패한 키워드 — 0 이 아니라 「실패」로 표시
						// 계정 막힘(failReason WING_BLOCKED)으로 못 가져온 키워드는 「조회 제한」
						if (event.data.failed && targetKeyword) {
							const failText = event.data.failReason === 'WING_BLOCKED' ? '조회 제한' : '실패';
							targetKeyword.쿠팡중간판매가 = null;
							failCells.쿠팡중간판매가 = failText;
							targetKeyword.카테고리명 = failText;
							const why = {
								WING_LOGIN: '쿠팡 윙 로그인이 풀려',
								BLOCKED: '쿠팡이 잠시 막아',
								RATE_LIMITED: '쿠팡 윙에 요청이 몰려',
							}[event.data.failReason];
							// retryAfterMin = 쿠플러스 CLI 가 쿠팡 거절이 잇따라 쉬는 남은 분(확장 pausedMinOf) — «몰림·잠시 뒤» 대신 그 분을 보인다
							if (event.data.retryAfterMin) this.collectFailNotice = `쿠팡 거절이 잇따라 쿠플러스가 쿠팡 윙 조회를 약 ${event.data.retryAfterMin}분 쉬고 있어요. 「실패」로 표시된 키워드는 ${event.data.retryAfterMin}분 뒤 다시 수집해 주세요.`;
							else if (event.data.paused) this.collectFailNotice = '쿠팡 거절이 잇따라 쿠플러스가 쿠팡 윙 조회를 잠시 쉬고 있어요(남은 시간 모름). 「실패」로 표시된 키워드는 잠시 뒤 다시 수집해 주세요.';
							else if (why) this.collectFailNotice = `${why} 「실패」로 표시된 키워드의 판매가·판매량을 못 가져왔어요. 잠시 뒤 다시 수집해 주세요.`;
						} else
						// 빈 배열(상위 상품 0 개) — 셀 것 없는 칸은 null(«모름»)
						if (topProducts.length === 0) {
							if (targetKeyword) {
								for (const col of Object.keys(failCells)) delete failCells[col];   // 아래에서 모든 칸을 새로 씀
								// 판매가 없음 = null(0원이 아님) — 표에는 «판매가 없음» · 엑셀은 빈 칸
								targetKeyword.쿠팡중간판매가 = null;
								targetKeyword.쿠팡평균판매가 = null;
								targetKeyword.쿠팡판매가범위 = null;
								targetKeyword.상위그로스비율 = 0;
								targetKeyword.상위로켓비율 = 0;
								targetKeyword.상위윙비율 = 0;
								targetKeyword.카테고리명 = keywordCategory?.category || '-';
								targetKeyword.카테고리적합도 = (keywordCategory?.rate || 0) + "%";
								// 상위 상품이 없으면 조회수·판매량·매출·전환율도 셀 것 없음 = null(«모름» · 0 아님 · couponprice0-4)
								targetKeyword.평균월조회수 = null;
								targetKeyword.중간월조회수 = null;
								targetKeyword.최대월조회수 = null;
								targetKeyword.최소월조회수 = null;
								targetKeyword.평균월판매량 = null;
								targetKeyword.중간월판매량 = null;
								targetKeyword.최대월판매량 = null;
								targetKeyword.최소월판매량 = null;
								targetKeyword.평균월매출 = null;
								targetKeyword.중간월매출 = null;
								targetKeyword.최대월매출 = null;
								targetKeyword.최소월매출 = null;
								targetKeyword.평균전환율 = null;
								targetKeyword.중간전환율 = null;
								targetKeyword.최대전환율 = null;
								targetKeyword.최소전환율 = null;
							}
						} else {
						// 판매가 없는 상품(price null)은 판매가 셈에서 뺀다 — 0원으로 섞이면 중간·평균·범위가 낮아진다
						var array = topProducts.map(f => f.price).filter(v => typeof v === 'number').sort((a, b) => { return b - a });
						var index25 = Math.floor(array.length * 0.25);
						var index50 = Math.floor(array.length * 0.50);
						var index75 = Math.floor(array.length * 0.75);
						if (targetKeyword) {
							// 기존 데이터 할당
							targetKeyword.쿠팡중간판매가 = array.length ? array[index50] : null;
							targetKeyword.쿠팡평균판매가 = array.length ? Math.round(array.reduce((pv, cv) => { return pv + cv }, 0) / array.length) : null;
							targetKeyword.쿠팡판매가범위 = array.length ? array[index75] + "~" + array[index25] : null;
							targetKeyword.상위그로스비율 = Math.round(topProducts.filter(f => f.type == 'jet').length / topProducts.length * 100) / 100;
							targetKeyword.상위로켓비율 = Math.round(topProducts.filter(f => f.type == 'rocket').length / topProducts.length * 100) / 100;
							targetKeyword.상위윙비율 = Math.round(topProducts.filter(f => f.type == 'wing').length / topProducts.length * 100) / 100;
							// 카테고리를 못 읽으면(keywordCategory 없음·칸 없음) 죽지 않고 모름(null · 화면 «모름») · 크게 남김(couponprice0-5)
							if (keywordCategory?.category == null || keywordCategory?.rate == null) console.error('[keywordCollect] 카테고리 못 읽음:', targetKeyword.keyword, keywordCategory ? Object.keys(keywordCategory) : keywordCategory);
							targetKeyword.카테고리명 = keywordCategory?.category ?? null;
							targetKeyword.카테고리적합도 = keywordCategory?.rate == null ? null : keywordCategory.rate + "%";
						}
						// 판매량·매출의 출처(pre-matching)를 못 받았으면 0 이 아니라 「실패」+ 까닭 띠
						const metricCols = ['평균월조회수', '중간월조회수', '최대월조회수', '최소월조회수', '평균월판매량', '중간월판매량', '최대월판매량', '최소월판매량',
							'평균월매출', '중간월매출', '최대월매출', '최소월매출', '평균전환율', '중간전환율', '최대전환율', '최소전환율'];
						if (keywordCategory) for (const col of metricCols) delete failCells[col];
						if (targetKeyword && keywordCategory?.failed) {
							for (const col of metricCols) { targetKeyword[col] = null; failCells[col] = '실패'; }
							const why = { WING_LOGIN: '쿠팡 윙 로그인이 풀려', BLOCKED: '쿠팡이 잠시 막아', RATE_LIMITED: '쿠팡 윙에 요청이 몰려' }[keywordCategory.failReason] || '쿠팡 윙 응답을 받지 못해';
							this.collectFailNotice = `${why} 「실패」로 표시된 키워드의 판매량·매출을 못 가져왔어요. 잠시 뒤 다시 수집해 주세요.`;
						} else
						// keywordCategory.categories 배열에서 통계 계산
						if (targetKeyword && keywordCategory?.categories && keywordCategory.categories.length > 0) {
							const categories = keywordCategory.categories;

							// 상품 하나의 칸을 모르면(null·없음) 그 칸 셈에서 뺀다 — 0 으로 섞으면 평균·중간·최소가 0 쪽(진짜 0 은 그대로 · couponprice0-5)
							const known = (v) => typeof v === 'number' && Number.isFinite(v);
							// 월조회수 통계 (pvLast28Day)
							const pvValues = categories.map(c => c.pvLast28Day).filter(known).sort((a, b) => b - a);
							const pvSum = pvValues.reduce((sum, val) => sum + val, 0);
							targetKeyword.평균월조회수 = pvValues.length ? Math.round(pvSum / pvValues.length) : null;
							targetKeyword.중간월조회수 = pvValues.length ? pvValues[Math.floor(pvValues.length * 0.5)] : null;
							targetKeyword.최대월조회수 = pvValues.length ? pvValues[0] : null;
							targetKeyword.최소월조회수 = pvValues.length ? pvValues[pvValues.length - 1] : null;

							// 월판매량 통계 (salesLast28d)
							const salesValues = categories.map(c => c.salesLast28d).filter(known).sort((a, b) => b - a);
							const salesSum = salesValues.reduce((sum, val) => sum + val, 0);
							targetKeyword.평균월판매량 = salesValues.length ? Math.round(salesSum / salesValues.length) : null;
							targetKeyword.중간월판매량 = salesValues.length ? salesValues[Math.floor(salesValues.length * 0.5)] : null;
							targetKeyword.최대월판매량 = salesValues.length ? salesValues[0] : null;
							targetKeyword.최소월판매량 = salesValues.length ? salesValues[salesValues.length - 1] : null;
							// 판매 기록 있는 상품이 0 이면 0 이 «안 팔림» 처럼 보인다 — 표본 수와 함께 까닭 한 줄
							// 쿠팡이 조회수를 끝내 안 줬으면(확장 metricsUnavailable) 판매 0 까닭 대신 «다시 수집» 안내
							const zeroWhy = this.metricsMissingReason(targetKeyword.keyword, keywordCategory) || this.salesZeroReason(targetKeyword.keyword, categories);
							if (zeroWhy && !this.salesZeroNotice.includes(zeroWhy)) this.salesZeroNotice = this.salesZeroNotice ? `${this.salesZeroNotice} · ${zeroWhy}` : zeroWhy;

							// 월매출 통계 (월판매량 * salePrice) — 판매가 모름(null·0원)인 상품은 뺀다 · 다 모르면 null(«모름» · 0원 매출 아님)
							const revenueValues = categories.filter(c => typeof c.salePrice === 'number' && c.salePrice > 0 && known(c.salesLast28d))
								.map(c => c.salesLast28d * c.salePrice).sort((a, b) => b - a);
							const revenueSum = revenueValues.reduce((sum, val) => sum + val, 0);
							targetKeyword.평균월매출 = revenueValues.length ? Math.round(revenueSum / revenueValues.length) : null;
							targetKeyword.중간월매출 = revenueValues.length ? Math.round(revenueValues[Math.floor(revenueValues.length * 0.5)]) : null;
							targetKeyword.최대월매출 = revenueValues.length ? Math.round(revenueValues[0]) : null;
							targetKeyword.최소월매출 = revenueValues.length ? Math.round(revenueValues[revenueValues.length - 1]) : null;

							// 전환율 통계 (월판매량 / 월조회수)
							const conversionValues = categories.filter(c => known(c.pvLast28Day) && known(c.salesLast28d)).map(c => {
								const pv = c.pvLast28Day;
								const sales = c.salesLast28d;
								return pv > 0 ? (sales / pv) : 0;
							}).sort((a, b) => b - a);
							const conversionSum = conversionValues.reduce((sum, val) => sum + val, 0);
							targetKeyword.평균전환율 = conversionValues.length ? Math.round(conversionSum / conversionValues.length * 10000) / 100 : null; // 백분율로 표시
							targetKeyword.중간전환율 = conversionValues.length ? Math.round(conversionValues[Math.floor(conversionValues.length * 0.5)] * 10000) / 100 : null;
							targetKeyword.최대전환율 = conversionValues.length ? Math.round(conversionValues[0] * 10000) / 100 : null;
							targetKeyword.최소전환율 = conversionValues.length ? Math.round(conversionValues[conversionValues.length - 1] * 10000) / 100 : null;
						} else if (targetKeyword) {
							// 윙 상품(표본)이 0 개 = 셀 것 없음 → 모름(null · 0 아님) — 확장은 «진짜 0 개»와 «빈 응답»을 가르지 않는다(background.js getCategoryFromKeyword · couponprice0-4)
							targetKeyword.평균월조회수 = null;
							targetKeyword.중간월조회수 = null;
							targetKeyword.최대월조회수 = null;
							targetKeyword.최소월조회수 = null;
							targetKeyword.평균월판매량 = null;
							targetKeyword.중간월판매량 = null;
							targetKeyword.최대월판매량 = null;
							targetKeyword.최소월판매량 = null;
							targetKeyword.평균월매출 = null;
							targetKeyword.중간월매출 = null;
							targetKeyword.최대월매출 = null;
							targetKeyword.최소월매출 = null;
							targetKeyword.평균전환율 = null;
							targetKeyword.중간전환율 = null;
							targetKeyword.최대전환율 = null;
							targetKeyword.최소전환율 = null;
						}
					} // else 블록 끝
					if (targetKeyword) this.$set(targetKeyword, '실패칸', failCells);
					}
				}
				await this.saveCurrentGroup();
				this.$nextTick(() => {
					this.showlist = true;
					this.showspinner = false;
				})
			}
			if (event.data.res && event.data.res === 'keywordSales') {
				this.showlist = false;
				console.log(event.data)
				if (this.showCoupangOneStarRate) {
					if (!this.headers.find(f => f.value == '쿠팡1점리뷰비율')) {
						this.headers.splice(-1, 0, { text: '쿠팡\n1점리뷰비율', value: '쿠팡1점리뷰비율', align: 'center', width: 100, isSlot: true });
					}
				}
				if (this.showCoupangMedianSales) {
					if (!this.headers.find(f => f.value == '쿠팡중간매출')) {
						this.headers.splice(-1, 0, { text: '쿠팡\n중간매출', value: '쿠팡중간매출', align: 'center', width: 100, isSlot: true });
					}
				}
				if (this.showCoupangAvgSales) {
					if (!this.headers.find(f => f.value == '쿠팡평균매출')) {
						this.headers.splice(-1, 0, { text: '쿠팡\n평균매출', value: '쿠팡평균매출', align: 'center', width: 100, isSlot: true });
					}
				}

				var keywordSales = event.data.keywordSales;
				keyword = event.data.keyword;
				console.log(keywordSales)
				// 윙이 끝내 429 로 막아 못 본 상품은 «모름» — 수집 한 번에 한 번만 알린다
				if (!this.rateLimitAlerted && (keywordSales || []).some(r => r && r.rateLimited)) {
					this.rateLimitAlerted = true;
					alert('쿠팡이 잠시 막음 — 몇 분 뒤 다시 수집해 주세요. (판매량을 못 본 상품은 «모름»으로 계산에서 뺍니다)');
				}
				// 확장이 리뷰를 못 받음(대량 수집 = 쇼핑 리뷰 0 · 판 #734) → 1점 리뷰 비율은 «모름»(null) · 수집 한 번에 한 번 알림
				const reviewOff = (keywordSales || []).find(r => r && r.reviewUnavailable);
				if (reviewOff && !this.reviewOffAlerted) {
					this.reviewOffAlerted = true;
					alert(`${reviewOff.reviewUnavailable} 쿠팡 1점 리뷰 비율은 «모름»으로 둡니다.`);
				}
				var worstReviewRate = reviewOff ? null : Math.round(keywordSales.reduce((pv, cv) => { return pv + parseInt(cv.worstReviewQty) }, 0) / keywordSales.reduce((pv, cv) => { return pv + parseInt(cv.totalReviewQty) }, 0) * 10000) / 100 + "%"
				if (keywordSales) {
					if (this.keywords.find(f => f.keyword.replaceAll(" ", "") == keyword.replaceAll(" ", ""))) {
						// 윙 조회 실패 상품은 null(모름) — 알려진 값만 계산, 전부 모름이면 null
						array = keywordSales.map(f => f.monthSales).filter(v => v != null).sort((a, b) => { return b - a });
						index50 = Math.floor(array.length * 0.50);
						this.keywords.find(f => f.keyword.replaceAll(" ", "") == keyword.replaceAll(" ", "")).쿠팡중간매출 = array.length ? array[index50] : null;
						this.keywords.find(f => f.keyword.replaceAll(" ", "") == keyword.replaceAll(" ", "")).쿠팡평균매출 = array.length ? Math.round(array.reduce((pv, cv) => { return pv + cv }, 0) / array.length) : null;
						this.keywords.find(f => f.keyword.replaceAll(" ", "") == keyword.replaceAll(" ", "")).쿠팡1점리뷰비율 = worstReviewRate;
					}
				}
				await this.saveCurrentGroup();
				this.$nextTick(() => {
					this.showlist = true;
					this.showspinner = false;
				})
			}

			if (event.data.res && event.data.res === 'relkeywordsrate') {
				this.loadingrate = '(' + event.data.n + '차)' + (event.data.rate * 100).toFixed(0) + '%';
			}
			if (event.data.res && event.data.res === 'relatedkeywords') {
				console.log(event.data.relatedkeywords)
				var arr = event.data.relatedkeywords;
				var ar = [];
				if (this.related) {
					ar = [this.targetKeyword]
				}
				// console.log(arr)
				arr.forEach(ele => {
					if (!ar.includes(ele)) {
						ar.push(ele)
					}
				})
				var keywords = [];
				// console.log(ar)
				ar.forEach(ele => {
					if (!this.rowlines.find(element => element.targetKeyword == ele)) {
						keywords.push(ele);
					}
				})
				// console.log(keywords)
				// this.rowlines = [];
				var cnt = 0
				for (var i = 0; i < keywords.length; i++) {
					cnt++
					this.rowlines.push({
						targetKeyword: keywords[i],
						wing1p: '',
						rocket1p: '',
						growth1p: '',
						adrate: '',
						adqty: '',
						adplace: '',
						cpc: '',
						cpchigh: '',
						cpclow: '',
						rocketrate: '',
						rocketqty: '',
						totalqty: '',
						crate: '',
						review1p: '',
						review1phigh: '',
						review1plow: '',
						review1pmiddle: '',
						n1psalesqty: '',
						n1psalesqtyhigh: '',
						n1psalesqtylow: '',
						n1psalesqtymiddle: '',
						n1psales: '',
						n1psaleshigh: '',
						n1psaleslow: '',
						n1psalesmiddle: '',

						nrate: '',
						pricen1phigh: '',
						pricen1plow: '',
						pricen1p: '',
						pricen1pmiddle: '',
						price1phigh: '',
						price1plow: '',
						price1p: '',
						price1pmiddle: '',
						wingrate: '',
					})

				}
				if (cnt == keywords.length) {
					this.importresults(keywords)
				}
			}
		}
		window.addEventListener('message', this.messageEventHandler);

		console.log(navigator)
		this.getauthNo()
	},
	computed: {
		// 광고센터 탭은 월검색량(쿠팡월검색량·CPC) 켤 때만 쓴다 — 확장도 그때만 요구한다(kwsrcfix-1)
		desc2() {
			return this.showCoupangMonthlySearch ? '쿠팡wing, 광고센터를 새탭에서 열고 수집해주세요' : '쿠팡wing 을 새탭에서 열고 수집해주세요'
		},
		slotHeaders() {
			// 명시적으로 정의한 슬롯 제외
			const excludedSlots = ['add', 'del', '검색트렌드지난달', '키워드트렌드지난달네이버'];
			return this.headers.filter(header => !excludedSlots.includes(header.value) && header.isSlot);
		}
	},
	methods: {
		updateHeaders() {
			console.log('updateHeaders 호출됨, keywords 개수:', this.keywords.length);
			if (this.keywords.length > 0) {
				console.log('첫 번째 키워드 데이터:', this.keywords[0]);
			}

			// 기본 headers 설정 (맨 앞에 고정)
			let baseHeaders = [
				{ text: '키워드', value: 'keyword', align: 'center', width: 150, isSlot: false },
				{ text: '연관\n자동완성', value: 'add', align: 'center', width: 50, isSlot: true },
				{ text: '삭제', value: 'del', align: 'center', width: 50, isSlot: true }
			];

			// 분석 결과 컬럼들을 뒤에 추가
			if (this.keywords.length > 0) {
				// 1. 검색트렌드 관련 컬럼
				if (this.keywords.some(k => k.키워드트렌드지난달네이버 !== undefined)) {
					baseHeaders.push({ text: '키워드트렌드\n지난달(네이버)', value: '키워드트렌드지난달네이버', align: 'center', width: 120, isSlot: true });
				}
				if (this.keywords.some(k => k.검색트렌드지난달 !== undefined)) {
					baseHeaders.push({ text: '검색트렌드\n지난달', value: '검색트렌드지난달', align: 'center', width: 100, isSlot: true });
				}
				if (this.keywords.some(k => k.검색트렌드이번달 !== undefined)) {
					baseHeaders.push({ text: '검색트렌드\n이번달', value: '검색트렌드이번달', align: 'center', width: 100, isSlot: true });
				}
				if (this.keywords.some(k => k['검색트렌드+3개월'] !== undefined)) {
					baseHeaders.push({ text: '검색트렌드\n+3개월', value: '검색트렌드+3개월', align: 'center', width: 100, isSlot: true });
				}
				if (this.keywords.some(k => k['검색트렌드+6개월'] !== undefined)) {
					baseHeaders.push({ text: '검색트렌드\n+6개월', value: '검색트렌드+6개월', align: 'center', width: 100, isSlot: true });
				}

				// 2. CPC 관련 컬럼
				if (this.keywords.some(k => k.쿠팡키워드CPC !== undefined)) {
					baseHeaders.push({ text: '쿠팡\n키워드CPC', value: '쿠팡키워드CPC', align: 'center', width: 100, isSlot: true });
				}

				// 3. 쿠팡 가격 관련 컬럼
				if (this.keywords.some(k => k.쿠팡중간판매가 !== undefined)) {
					baseHeaders.push({ text: '쿠팡\n중간판매가', value: '쿠팡중간판매가', align: 'center', width: 100, isSlot: true });
				}
				if (this.keywords.some(k => k.쿠팡판매가범위 !== undefined)) {
					baseHeaders.push({ text: '쿠팡판매가\n범위(25~75%)', value: '쿠팡판매가범위', align: 'center', width: 100, isSlot: true });
				}
				if (this.keywords.some(k => k.쿠팡평균판매가 !== undefined)) {
					baseHeaders.push({ text: '쿠팡\n평균판매가', value: '쿠팡평균판매가', align: 'center', width: 100, isSlot: true });
				}

				// 4. 상위 비율 관련 컬럼
				if (this.keywords.some(k => k.상위그로스비율 !== undefined)) {
					baseHeaders.push({ text: '상위\n그로스비율', value: '상위그로스비율', align: 'center', width: 100, isSlot: true });
				}
				if (this.keywords.some(k => k.상위로켓비율 !== undefined)) {
					baseHeaders.push({ text: '상위\n로켓비율', value: '상위로켓비율', align: 'center', width: 100, isSlot: true });
				}
				if (this.keywords.some(k => k.상위윙비율 !== undefined)) {
					baseHeaders.push({ text: '상위\n윙비율', value: '상위윙비율', align: 'center', width: 100, isSlot: true });
				}

				// 5. 카테고리 관련 컬럼
				if (this.keywords.some(k => k.카테고리명 !== undefined)) {
					baseHeaders.push(
						{ text: '카테고리명', value: '카테고리명', align: 'center', width: 200, isSlot: true },
						{ text: '카테고리\n적합도', value: '카테고리적합도', align: 'center', width: 100, isSlot: true }
					);
				}

				// 6. 조회수, 판매량, 매출, 전환율 관련 컬럼
				const avgViewsColumns = [
					{ key: '평균월조회수', text: '평균월조회수' },
					{ key: '중간월조회수', text: '중간월조회수' },
					{ key: '최대월조회수', text: '최대월조회수' },
					{ key: '최소월조회수', text: '최소월조회수' },
					{ key: '평균월판매량', text: '평균월판매량' },
					{ key: '중간월판매량', text: '중간월판매량' },
					{ key: '최대월판매량', text: '최대월판매량' },
					{ key: '최소월판매량', text: '최소월판매량' },
					{ key: '평균월매출', text: '평균월매출' },
					{ key: '중간월매출', text: '중간월매출' },
					{ key: '최대월매출', text: '최대월매출' },
					{ key: '최소월매출', text: '최소월매출' },
					{ key: '평균전환율', text: '평균전환율' },
					{ key: '중간전환율', text: '중간전환율' },
					{ key: '최대전환율', text: '최대전환율' },
					{ key: '최소전환율', text: '최소전환율' }
				];

				avgViewsColumns.forEach(column => {
					if (this.keywords.some(k => k[column.key] !== undefined)) {
						baseHeaders.push({ text: column.text, value: column.key, align: 'center', width: 100, isSlot: true });
					}
				});

				// 7. 매출 관련 컬럼 (keywordSales에서 추가되는 컬럼들)
				// if (this.keywords.some(k => k.쿠팡중간매출 !== undefined)) {
				// 	baseHeaders.push({ text: '쿠팡\n중간매출', value: '쿠팡중간매출', align: 'center', width: 100, isSlot: true });
				// }
				// if (this.keywords.some(k => k.쿠팡평균매출 !== undefined)) {
				// 	baseHeaders.push({ text: '쿠팡\n평균매출', value: '쿠팡평균매출', align: 'center', width: 100, isSlot: true });
				// }
				// if (this.keywords.some(k => k.쿠팡1점리뷰비율 !== undefined)) {
				// 	baseHeaders.push({ text: '쿠팡\n1점리뷰비율', value: '쿠팡1점리뷰비율', align: 'center', width: 100, isSlot: true });
				// }
			}

			// Vue의 반응성을 위해 강제로 새 배열 할당
			this.headers = [...baseHeaders];
			console.log('updateHeaders 완료, 최종 헤더 개수:', this.headers.length);
			console.log('최종 헤더:', this.headers.map(h => h.text));

			// 강제로 컴포넌트 다시 렌더링
			this.$forceUpdate();
		},
		async clearKeywords() {
			try {
				this.keywords = [];
				this.showlist = false;
				await this.saveCurrentGroup();
			} catch (error) {
				console.error('키워드 삭제 실패:', error);
			}
		},
		async deleteKeywords() {
			if (this.tableSelectedItem.length > 0) {
				if (confirm(this.tableSelectedItem.length + '개의 키워드를 삭제하시겠습니까?')) {

					// ✔ 선택된 항목을 복제해둔다
					const selectedItems = [...this.tableSelectedItem];

					// 복제본을 순회하면서 삭제
					for (const item of selectedItems) {
						await this.deleteKeyword(item);
					}

					// 다 끝난 후에 한 번에 비우기
					this.tableSelectedItem = [];
				}
			} else {
				if (confirm('전체 키워드를 삭제하시겠습니까?')) {
					await this.clearKeywords();
					this.headers = [
						{ text: '키워드', value: 'keyword', align: 'center', width: 150, isSlot: false },
						{ text: '연관\n자동완성', value: 'add', align: 'center', width: 50, isSlot: true },
						{ text: '삭제', value: 'del', align: 'center', width: 50, isSlot: true },
					];
				}
			}
		}
		,
		keyinkeywords() {
			if (this.targetKeyword.length > 10 && this.targetKeyword.split(' ').length > 2) {
				console.log(this.targetKeyword.split(' '))
			}
		},
		predictFutureSearchVolumes(monthlySearch, oneYearData) {
			// 월별 검색량 문자열을 숫자로 변환(콤마 제거)
			monthlySearch = parseInt(monthlySearch) > 0 ? Number(String(monthlySearch).replace(/,/g, '')) : 0;
			console.log(monthlySearch, oneYearData);
			const today = new Date();

			// 날짜를 YYYY-MM-DD로 포맷하는 헬퍼 함수
			function formatDate(date) {
				const y = date.getFullYear();
				const m = String(date.getMonth() + 1).padStart(2, '0');
				const d = String(date.getDate()).padStart(2, '0');
				return `${y}-${m}-${d}`;
			}

			// 특정 기간(시작일~종료일) 내 평균 ratio 계산 함수
			// 날짜가 oneYearData에 없으면 ratio=0으로 계산
			function getAverageRatio(startDate, endDate) {
				const startStr = formatDate(startDate);
				const endStr = formatDate(endDate);

				// 기간 내 총 일수 계산
				const dayCount = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1;

				let totalRatio = 0;
				let count = 0;

				for (let i = 0; i < dayCount; i++) {
					const currentDate = new Date(startDate.getTime());
					currentDate.setDate(currentDate.getDate() + i);

					const currentStr = formatDate(currentDate);
					if (currentStr < startStr || currentStr > endStr) continue; // 범위 외는 제외

					// oneYearData에서 해당 날짜를 찾는다
					const dataItem = oneYearData.find(item => item.period === currentStr);

					// 없으면 ratio=0 처리
					const ratioValue = dataItem ? dataItem.ratio : 0;
					totalRatio += ratioValue;
					count++;
				}

				if (count === 0) return 0;
				return totalRatio / count;
			}

			// 직전 30일 평균 ratio 계산
			const lastMonthEnd = new Date(today);
			const lastMonthStart = new Date(today);
			lastMonthStart.setDate(lastMonthStart.getDate() - 30);
			const lastMonthAvgRatio = getAverageRatio(lastMonthStart, lastMonthEnd);

			// ratio 1 단위당 실제 검색량 변환
			const ratioToVolumeFactor = lastMonthAvgRatio === 0 ? 0 : (monthlySearch / lastMonthAvgRatio);

			// 미래 기간 설정(1년 전 동일 기간 사용)
			const oneMonthLaterStart = new Date(today);
			oneMonthLaterStart.setMonth(oneMonthLaterStart.getMonth() + 1);
			const oneMonthLaterEnd = new Date(oneMonthLaterStart);
			oneMonthLaterEnd.setDate(oneMonthLaterEnd.getDate() + 30);

			const oneMonthLaterStartLastYear = new Date(oneMonthLaterStart);
			oneMonthLaterStartLastYear.setFullYear(oneMonthLaterStartLastYear.getFullYear() - 1);
			const oneMonthLaterEndLastYear = new Date(oneMonthLaterEnd);
			oneMonthLaterEndLastYear.setFullYear(oneMonthLaterEndLastYear.getFullYear() - 1);

			// 3개월 후 예측
			const threeMonthsLaterStart = new Date(today);
			threeMonthsLaterStart.setMonth(threeMonthsLaterStart.getMonth() + 3);
			const threeMonthsLaterEnd = new Date(threeMonthsLaterStart);
			threeMonthsLaterEnd.setDate(threeMonthsLaterEnd.getDate() + 30);

			const threeMonthsLaterStartLastYear = new Date(threeMonthsLaterStart);
			threeMonthsLaterStartLastYear.setFullYear(threeMonthsLaterStartLastYear.getFullYear() - 1);
			const threeMonthsLaterEndLastYear = new Date(threeMonthsLaterEnd);
			threeMonthsLaterEndLastYear.setFullYear(threeMonthsLaterEndLastYear.getFullYear() - 1);

			// 6개월 후 예측
			const sixMonthsLaterStart = new Date(today);
			sixMonthsLaterStart.setMonth(sixMonthsLaterStart.getMonth() + 6);
			const sixMonthsLaterEnd = new Date(sixMonthsLaterStart);
			sixMonthsLaterEnd.setDate(sixMonthsLaterEnd.getDate() + 30);

			const sixMonthsLaterStartLastYear = new Date(sixMonthsLaterStart);
			sixMonthsLaterStartLastYear.setFullYear(sixMonthsLaterStartLastYear.getFullYear() - 1);
			const sixMonthsLaterEndLastYear = new Date(sixMonthsLaterEnd);
			sixMonthsLaterEndLastYear.setFullYear(sixMonthsLaterEndLastYear.getFullYear() - 1);

			// 과거 1년 전 동일 기간의 평균 ratio 계산
			const avgRatioOneMonthLater = getAverageRatio(oneMonthLaterStartLastYear, oneMonthLaterEndLastYear);
			const avgRatioThreeMonthsLater = getAverageRatio(threeMonthsLaterStartLastYear, threeMonthsLaterEndLastYear);
			const avgRatioSixMonthsLater = getAverageRatio(sixMonthsLaterStartLastYear, sixMonthsLaterEndLastYear);

			// 예측 검색량 계산
			const oneMonthLaterVolume = ratioToVolumeFactor * avgRatioOneMonthLater;
			const threeMonthsLaterVolume = ratioToVolumeFactor * avgRatioThreeMonthsLater;
			const sixMonthsLaterVolume = ratioToVolumeFactor * avgRatioSixMonthsLater;

			return {
				oneMonthLaterVolume,
				threeMonthsLaterVolume,
				sixMonthsLaterVolume
			};
		},
		// 월판매량 0 까닭 — 윙 pre-matching 상품 중 판매 기록 있는 상품이 0 일 때만 한 줄(아니면 빈 글)
		metricsMissingReason(keyword, keywordCategory) {
			if (!keywordCategory || keywordCategory.metricsUnavailable !== true) return '';
			return `${keyword}: 쿠팡이 조회수를 주지 않았어요(다시 물어도 같음) — 월조회수·월판매량 0 은 실제 값이 아닙니다. 잠시 뒤 다시 수집해 주세요`;
		},
		salesZeroReason(keyword, categories) {
			if (!Array.isArray(categories) || categories.length === 0) return '';
			const sold = categories.filter(c => Number(c && c.salesLast28d) > 0).length;
			if (sold > 0) return '';
			const viewed = categories.filter(c => Number(c && c.pvLast28Day) > 0).length;
			return `${keyword}: 윙 상품 ${categories.length}개 중 판매 기록 있는 상품 0개(조회 있는 상품 ${viewed}개) — 월판매량 0 은 안 팔린다는 뜻이 아니라 표본에 판매 기록이 없다는 뜻이에요`;
		},
		checkShowItems() {
			if (this.check1) {
				this.showCoupangMonthlySearch = true;
				this.showCoupangRecCPC = true;
				this.showSearchTrend = true;
			} else {
				this.showCoupangMonthlySearch = false;
				this.showCoupangRecCPC = false;
				this.showSearchTrend = false;
			}
			if (this.check2) {
				this.showCoupangMedianPrice = true;
				this.showCoupangPriceRange = true;
				this.showCoupangAvgPrice = true;
				// 빠른수집(pre-matching)은 윙 상품을 구분 못 해 type 비율이 부정확 → 해당 모드에선 제외
				const showTypeRate = this.collectMode !== 'fast';
				this.showCoupangTopGrowthRate = showTypeRate;
				this.showCoupangTopRocketRate = showTypeRate;
				this.showCoupangTopWingRate = showTypeRate;
				this.showOptimalCategory = true;
				this.showCoupangAvgViews = true;
			} else {
				this.showCoupangMedianPrice = false;
				this.showCoupangPriceRange = false;
				this.showCoupangAvgPrice = false;
				this.showCoupangTopGrowthRate = false;
				this.showCoupangTopRocketRate = false;
				this.showCoupangTopWingRate = false;
				this.showOptimalCategory = false;
				this.showCoupangAvgViews = false;
			}
			if (this.check3) {
				this.showCoupangOneStarRate = true;
				this.showCoupangMedianSales = true;
				this.showCoupangAvgSales = true;
				// this.showCoupangMedianViews = true;

			} else {
				this.showCoupangOneStarRate = false;
				this.showCoupangMedianSales = false;
				this.showCoupangAvgSales = false;
				// this.showCoupangMedianViews = false;

			}
		},
		// 선택된 키워드(없으면 전체)를 소싱관리 보드에 stage 0(키워드선정) 행으로 담는다.
		// 시장수요 raw 필드는 키 그대로 보존 → 보드의 '시장수요' 모달에서 사용.
		async addToSourcingBoard() {
			const targets = this.tableSelectedItem.length > 0 ? this.tableSelectedItem : this.keywords;
			if (targets.length === 0) {
				alert('담을 키워드가 없습니다.');
				return;
			}
			if (!confirm(targets.length + '개의 키워드를 소싱관리에 담으시겠습니까?')) return;

			const rows = targets.map(item => ({
				키워드: item.keyword || '',
				카테고리: item.카테고리명 || '',
				상품명: '',
				카테고리적합도: item.카테고리적합도,
				쿠팡키워드CPC: item.쿠팡키워드CPC,
				쿠팡중간판매가: item.쿠팡중간판매가,
				쿠팡판매가범위: item.쿠팡판매가범위,
				쿠팡평균판매가: item.쿠팡평균판매가,
				상위그로스비율: item.상위그로스비율,
				상위로켓비율: item.상위로켓비율,
				상위윙비율: item.상위윙비율,
				평균월조회수: item.평균월조회수,
				중간월조회수: item.중간월조회수,
				최대월조회수: item.최대월조회수,
				최소월조회수: item.최소월조회수,
				평균월판매량: item.평균월판매량,
				중간월판매량: item.중간월판매량,
				최대월판매량: item.최대월판매량,
				최소월판매량: item.최소월판매량,
				// 보드의 '월매출' 컬럼·월수익 계산은 '월매출' 키만 본다 — 이걸 안 보내면
				// 키워드수집기로 담은 행은 월매출/월수익이 영원히 빈칸이었다.
				월매출: item.평균월매출,
				평균월매출: item.평균월매출,
				중간월매출: item.중간월매출,
				최대월매출: item.최대월매출,
				최소월매출: item.최소월매출,
				평균전환율: item.평균전환율,
				중간전환율: item.중간전환율,
				최대전환율: item.최대전환율,
				최소전환율: item.최소전환율,
				키워드트렌드지난달네이버: item.키워드트렌드지난달네이버,
				검색트렌드지난달: item.검색트렌드지난달,
				검색트렌드이번달: item.검색트렌드이번달,
				'검색트렌드+3개월': item['검색트렌드+3개월'],
				'검색트렌드+6개월': item['검색트렌드+6개월'],
				진도출처: '키워드수집기'
			}));

			try {
				const { data } = await axios.post('/api/sourcing/board/save', rows);
				if (data && data.res === 'OK') {
					alert(rows.length + '개를 소싱관리에 담았습니다.');
				} else {
					alert((data && data.alert) || '소싱관리 담기에 실패했습니다.');
				}
			} catch (e) {
				console.error('소싱관리 담기 실패', e);
				alert('소싱관리 담기에 실패했습니다.');
			}
		},
		downloadKeywords() {
			let downloadItems = [];

			// 다운로드할 아이템 선택
			if (this.tableSelectedItem.length > 0) {
				if (confirm(this.tableSelectedItem.length + '개의 키워드를 다운로드 하시겠습니까?')) {
					downloadItems = this.tableSelectedItem;
				}
			} else {
				if (confirm('전체 키워드를 다운로드 하시겠습니까?')) {
					downloadItems = this.keywords;
				}
			}

			if (downloadItems.length > 0) {
				// 데이터 정리 및 헤더와 키값 매칭
				const processedData = downloadItems.map(item => {
					let newItem = {
						'키워드': item.keyword,
						'검색트렌드_지난달_네이버': item.키워드트렌드지난달네이버,
						'검색트렌드_지난달': item.검색트렌드지난달,
						'검색트렌드_이번달': item.검색트렌드이번달,
						'검색트렌드_3개월': item['검색트렌드+3개월'],
						'검색트렌드_6개월': item['검색트렌드+6개월'],
						'쿠팡키워드CPC': item.쿠팡키워드CPC,
						'쿠팡중간판매가': item.쿠팡중간판매가,
						'쿠팡판매가범위': item.쿠팡판매가범위,
						'쿠팡평균판매가': item.쿠팡평균판매가,
						'상위그로스비율': item.상위그로스비율,
						'상위로켓비율': item.상위로켓비율,
						'상위윙비율': item.상위윙비율,
						'카테고리명': item.카테고리명,
						'카테고리적합도': item.카테고리적합도,
						'평균월조회수': item.평균월조회수,
						'중간월조회수': item.중간월조회수,
						'최대월조회수': item.최대월조회수,
						'최소월조회수': item.최소월조회수,
						'평균월판매량': item.평균월판매량,
						'중간월판매량': item.중간월판매량,
						'최대월판매량': item.최대월판매량,
						'최소월판매량': item.최소월판매량,
						'평균월매출': item.평균월매출,
						'중간월매출': item.중간월매출,
						'최대월매출': item.최대월매출,
						'최소월매출': item.최소월매출,
						'평균전환율': item.평균전환율,
						'중간전환율': item.중간전환율,
						'최대전환율': item.최대전환율,
						'최소전환율': item.최소전환율,
						// '쿠팡1점리뷰비율': item.쿠팡1점리뷰비율,
						// '쿠팡중간매출': item.쿠팡중간매출,
						// '쿠팡평균매출': item.쿠팡평균매출
					};

					// 수집 실패 칸은 엑셀에도 「실패」 그대로(숫자 칸 값은 null · 실패 글은 실패칸에)
					Object.entries(item.실패칸 || {}).forEach(([col, text]) => {
						if (col in newItem && newItem[col] == null) newItem[col] = text;
					});

					// undefined 값을 빈 문자열로 변환
					Object.keys(newItem).forEach(key => {
						if (newItem[key] === undefined) {
							newItem[key] = '';
						}
					});

					return newItem;
				});

				const date = new Date();
				const today = date.getFullYear() +
					("0" + (1 + date.getMonth())).slice(-2) +
					("0" + date.getDate()).slice(-2);

				const workBook = XLSX.utils.book_new();
				const workSheet = XLSX.utils.json_to_sheet(processedData, {
					header: Object.keys(processedData[0])
				});

				XLSX.utils.book_append_sheet(workBook, workSheet, '키워드분석');
				XLSX.writeFile(workBook, '키워드분석_' + today + '.xlsx');
			}
		},
		async deleteKeyword(item) {
			var i = this.keywords.findIndex(e => e.keyword == item.keyword);
			if (i !== -1) {
				// 키워드 배열에서 제거
				this.keywords = this.keywords.slice(0, i).concat(this.keywords.slice(i + 1));

				// 혹시 선택목록에 해당 item이 남아 있으면 제거
				const selIndex = this.tableSelectedItem.indexOf(item);
				if (selIndex !== -1) {
					this.tableSelectedItem.splice(selIndex, 1);
				}

				// 그룹에 즉시 저장 (삭제 후)
				await this.saveCurrentGroup();
			}

			if (this.keywords.length == 0) {
				this.headers = [
					{ text: '키워드', value: 'keyword', align: 'center', width: 150, isSlot: false },
					{ text: '연관\n자동완성', value: 'add', align: 'center', width: 50, isSlot: true },
					{ text: '삭제', value: 'del', align: 'center', width: 50, isSlot: true },
				];
			}
		},
		collectRelKeyword() {
			if (!this.targetKeyword) {
				alert('수집할 검색키워드를 입력해 주세요')
				return
			}
			if (!this.relKeywordChecked && !this.autoCompleteChecked) {
				alert('연관 또는 자동완성 키워드를 체크해 주세요')
				return
			}
			window.postMessage({ greeting: "getadkeyword", data: [this.targetKeyword], cnt: this.relCycle, relKeywordChecked: this.relKeywordChecked, autoCompleteChecked: this.autoCompleteChecked }, "*");
			this.loadingtext = '연관/자동완성 키워드 수집 중';
			this.loadingrate = '';
			this.showspinner = true;
			// this.showlist = false;
		},
		addRelKeyword(item) {
			window.postMessage({ greeting: "getadkeyword", data: [item.keyword], cnt: 1, relKeywordChecked: true, autoCompleteChecked: true }, "*");
			item.add = true;
			this.loadingtext = '연관/자동완성 키워드 수집 중';
			this.loadingrate = '';
			this.showspinner = true;
			// this.showlist = false;
		},
		async uploadfile(event) {
			try {
				this.showuploadspinner = true;

				const file = event.target.files[0];
				const data = await this.readFileAsync(file);
				const workbook = XLSX.read(data, { type: 'binary' });

				let addedCount = 0;
				let duplicateCount = 0;
				let emptyCount = 0;

				for (const sheetName of workbook.SheetNames) {
					const roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
					console.log(roa);

					for (var e of roa) {
						if (e.키워드 && e.키워드.length > 0) {
							// 공백 제거
							var keyword = e.키워드.replaceAll(" ", "");

							// 공백 제거 후 빈 문자열인지 체크
							if (keyword.length === 0) {
								emptyCount++;
								continue;
							}

							// 중복 체크 (공백 제거 후 비교)
							if (!this.keywords.find(f => f.keyword.replaceAll(" ", "") === keyword)) {
								this.keywords.push({
									keyword: keyword,
									add: false,
									del: false,
								})
								addedCount++;
							} else {
								duplicateCount++;
							}
						}
					}
				}

				// 결과 메시지 생성
				let resultMessage = `✅ ${addedCount}개의 키워드가 추가되었습니다.`;
				if (duplicateCount > 0) {
					resultMessage += `\n⚠️ ${duplicateCount}개의 중복 키워드가 제외되었습니다.`;
				}
				if (emptyCount > 0) {
					resultMessage += `\n⚠️ ${emptyCount}개의 빈 키워드가 제외되었습니다.`;
				}

				// 저장 완료 후 UI 업데이트
				await this.saveCurrentGroup();

				this.$nextTick(() => {
					this.showlist = true;
					this.showspinner = false;
					this.showuploadspinner = false;
					this.$bvModal.hide('excelupload');

					// 결과 알림
					if (addedCount > 0 || duplicateCount > 0 || emptyCount > 0) {
						alert(resultMessage);
					}
				});

			} catch (error) {
				alert(error.message);
				this.showuploadspinner = false;
				this.$bvModal.hide('excelupload');
			}
		},
		async readFileAsync(file) {
			return new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.onload = (e) => resolve(e.target.result);
				reader.onerror = (error) => reject(error);
				reader.readAsBinaryString(file);
			});
		},
		formatDownload() {
			var arr = [];
			var myHeader = ['키워드'];

			var dataWS = XLSX.utils.json_to_sheet(arr, { header: myHeader });

			const range = XLSX.utils.decode_range(dataWS['!ref']);
			range.e['c'] = myHeader.length - 1;
			dataWS['!ref'] = XLSX.utils.encode_range(range);

			var wb = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(wb, dataWS, '키워드업로드양식');
			// 엑셀 파일을 내보낸다.
			XLSX.writeFile(wb, '키워드업로드양식.xlsx');
		},
		async collectKeyword() {
			window.postMessage({ greeting: "collectKeyword", startRank: this.startRank, endRank: this.endRank }, "*",)
		},
		async getauthNo() {
			axios.post('/api/getAuthNo')
				.then(res => {
					this.auth = res.data.auth;
				}).catch(console.log)
		},
		resetitems() {
			this.rowlines = [];
		},
		searchenter(event) {
			if (event.keyCode === 13) {
				this.search();
			}
		},
		addKeyword(event) {
			if (event.keyCode === 13) {
				if (!this.targetKeyword) {
					return
				}

				// 콤마로 구분된 키워드들 처리
				if (this.targetKeyword.includes(',')) {
					const keywordArray = this.targetKeyword.split(',');
					let addedCount = 0;

					for (let keyword of keywordArray) {
						keyword = keyword.trim().replaceAll(" ", "");
						if (keyword.length > 0) {
							if (!this.keywords.find(e => e.keyword.replaceAll(" ", "") == keyword)) {
								this.keywords.push({
									keyword: keyword,
									add: false,
									del: false,
								});
								addedCount++;
							}
						}
					}

					if (addedCount > 0) {
						this.saveCurrentGroup().catch(error => console.error('키워드 저장 실패:', error));
						this.showlist = true;
					}

					this.targetKeyword = "";
					return;
				}

				// 기존 로직: 공백으로 구분된 키워드들 처리
				if (this.targetKeyword.length > 10 && this.targetKeyword.split(' ').length > 3) {
					for (var keyword of this.targetKeyword.split(' ')) {
						if (keyword.length > 0) {
							if (!this.keywords.find(e => e.keyword.replaceAll(" ", "") == keyword)) {
								this.keywords.push({
									keyword: keyword,
									add: false,
									del: false,
								})
							}
						}
					}
					this.saveCurrentGroup();
					this.targetKeyword = "";
					this.showlist = true;
					return
				}

				// 단일 키워드 처리
				if (!this.keywords.find(e => e.keyword.replaceAll(" ", "") == this.targetKeyword.replaceAll(" ", ""))) {
					if (this.targetKeyword.replaceAll(" ", "").length > 0) {
						this.keywords.push({
							keyword: this.targetKeyword.replaceAll(" ", ""),
							add: false,
							del: false,
						})
						this.saveCurrentGroup().catch(error => console.error('키워드 저장 실패:', error));
					}
					this.targetKeyword = "";
					this.showlist = true;
					return
				}
			}
		},
		collectRelKeywordEnter(event) {
			if (event.keyCode === 13) {
				this.$bvModal.hide('relKeyword');
				this.collectRelKeyword();
			}
		},
		startfocus() {
			this.$refs.cursor.focus();
		},
		middlelevel(arr) {
			arr.sort((a, b) => a - b);
			var val = parseInt(arr.length / 2);
			return arr[val];
		},

		// 키워드 그룹 관련 메서드들
		async createKeywordGroup() {
			const groupName = prompt('키워드 그룹명을 설정해 주세요');
			if (!groupName) {
				return;
			}
			if (this.keywordGroups[groupName]) {
				alert('이미 사용중인 키워드 그룹명입니다.');
				return;
			}

			// 새 그룹 생성
			this.keywordGroups[groupName] = [];
			await this.db.saveKeywordGroups(this.keywordGroups);

			// 새 그룹으로 전환
			this.activeKeywordGroup = groupName;
			this.keywords = [];
			this.showlist = false;
			this.updateHeaders();

			alert(`"${groupName}" 그룹이 생성되었습니다.`);
		},

		async switchKeywordGroup(groupName) {
			if (this.showspinner) {
				alert('수집중인 상태에서는 키워드 그룹 이동이 불가능합니다.');
				return;
			}

			if (groupName === this.activeKeywordGroup) {
				return;
			}

			// 현재 그룹의 키워드를 저장 (await로 완료 대기)
			await this.saveCurrentGroup();

			// 새 그룹으로 전환
			this.activeKeywordGroup = groupName;
			this.keywords = this.keywordGroups[groupName] || [];

			// 헤더를 먼저 기본값으로 리셋
			this.headers = [
				{ text: '키워드', value: 'keyword', align: 'center', width: 150, isSlot: false },
				{ text: '연관\n자동완성', value: 'add', align: 'center', width: 50, isSlot: true },
				{ text: '삭제', value: 'del', align: 'center', width: 50, isSlot: true }
			];

			// 테이블을 잠시 숨기고 헤더 업데이트 후 다시 표시
			this.showlist = false;

			// Vue의 반응성을 위해 nextTick 사용
			this.$nextTick(() => {
				this.updateHeaders();
				// 헤더 업데이트 후 다시 한 번 nextTick으로 테이블 표시
				this.$nextTick(() => {
					this.showlist = this.keywords.length > 0;
				});
			});
		},

		async deleteKeywordGroup(groupName) {
			if (groupName === 'Default') {
				alert('Default 키워드그룹은 삭제가 불가합니다.');
				return;
			}

			if (this.showspinner) {
				alert('수집중인 상태에서는 삭제가 불가능합니다.');
				return;
			}

			if (!confirm(`"${groupName}" 키워드그룹을 삭제하시겠습니까?`)) {
				return;
			}

			// 그룹 삭제
			delete this.keywordGroups[groupName];
			await this.db.saveKeywordGroups(this.keywordGroups);

			// Default 그룹으로 전환
			if (this.activeKeywordGroup === groupName) {
				this.activeKeywordGroup = 'Default';
				this.keywords = this.keywordGroups['Default'] || [];

				// 헤더를 먼저 기본값으로 리셋
				this.headers = [
					{ text: '키워드', value: 'keyword', align: 'center', width: 150, isSlot: false },
					{ text: '연관\n자동완성', value: 'add', align: 'center', width: 50, isSlot: true },
					{ text: '삭제', value: 'del', align: 'center', width: 50, isSlot: true }
				];

				// 테이블을 잠시 숨기고 헤더 업데이트 후 다시 표시
				this.showlist = false;

				// Vue의 반응성을 위해 nextTick 사용
				this.$nextTick(() => {
					this.updateHeaders();
					// 헤더 업데이트 후 다시 한 번 nextTick으로 테이블 표시
					this.$nextTick(() => {
						this.showlist = this.keywords.length > 0;
					});
				});
			}

			alert('삭제완료');
		},

		async saveCurrentGroup() {
			// 현재 활성 그룹에 현재 키워드들 저장
			this.keywordGroups[this.activeKeywordGroup] = [...this.keywords];
			await this.db.saveKeywordGroups(this.keywordGroups);
		},

		async clearCurrentKeywords() {
			if (this.showspinner) {
				alert('수집중인 상태에서는 초기화가 불가능합니다.');
				return;
			}

			if (!confirm('현재 그룹의 키워드를 모두 삭제하시겠습니까?')) {
				return;
			}

			this.keywords = [];
			this.keywordGroups[this.activeKeywordGroup] = [];
			await this.db.saveKeywordGroups(this.keywordGroups);
			this.showlist = false;
			this.updateHeaders();
		},
		async makerowlines(coupang, naver, cpc) {
			var cpcobj = cpc;
			console.log(coupang)
			console.log(naver)
			console.log(cpc)
			this.rowlines.forEach(e => {
				// console.log(coupang)
				// console.log(e)
				if (coupang.find(ele => ele.keyword == e.targetKeyword)) {
					var coupang1p = coupang.find(ele => ele.keyword == e.targetKeyword);
					var coupang1plist = coupang1p.productlists1p.filter(ele => ele.ad == false);
					// console.log(coupang1plist.map(ele => ele.ratingcount))
					var naver1p = naver.find(ele => ele.keyword == e.targetKeyword).keywordvalue;
					var naverlist = naver.find(ele => ele.keyword == e.targetKeyword).products;
					// console.log(naverlist.filter(ele => ele.purchaseCnt >= 0))
					for (var j = 0; j < naver1p.length; j++) {
						naver1p[j].long = parseInt(naver1p[j].long > naverlist.find(ele => ele.rank == naver1p[j].rank).purchaseCnt / 26 ? naver1p[j].long : naverlist.find(ele => ele.rank == naver1p[j].rank).purchaseCnt / 26);

					}

					var cpc = cpcobj ? cpcobj[e.targetKeyword] : '';

					e.wing1p = coupang1plist.filter(ele => ele.type == 'wing').length;
					e.rocket1p = coupang1plist.filter(ele => ele.type == 'rocket').length;
					e.growth1p = coupang1plist.filter(ele => ele.type == 'jet').length;
					e.wingrate = (e.wing1p / (e.wing1p + e.rocket1p + e.growth1p) * 100).toFixed(2);
					e.adqty = coupang1p.adqty;
					e.adplace = coupang1p.adplace;
					e.adrate = (coupang1p.adqty / coupang1p.adplace * 100).toFixed(2);
					e.cpchigh = cpc ? cpc.high : 0;
					e.cpclow = cpc ? cpc.low : 0;
					e.cpc = cpc ? cpc.suggested : 0;
					e.rocketqty = coupang1p.rocketqty;
					e.totalqty = coupang1p.totalqty;
					e.rocketrate = (coupang1p.rocketqty / coupang1p.totalqty * 100).toFixed(2);

					e.review1phigh = coupang1plist.reduce((pv, cv) => { return pv > cv.ratingcount ? pv : cv.ratingcount }, 0);
					e.review1plow = coupang1plist.reduce((pv, cv) => { return pv < cv.ratingcount ? pv : cv.ratingcount }, 100000000);
					e.review1p = Math.round(coupang1plist.reduce((pv, cv) => { return pv + cv.ratingcount }, 0) / coupang1plist.length);
					e.review1pmiddle = this.middlelevel(coupang1plist.map(ele => ele.ratingcount));

					e.price1phigh = coupang1plist.reduce((pv, cv) => { return pv > cv.price ? pv : cv.price }, 0);
					e.price1plow = coupang1plist.reduce((pv, cv) => { return pv < cv.price ? pv : cv.price }, 100000000);
					e.price1p = Math.round(coupang1plist.reduce((pv, cv) => { return pv + cv.price }, 0) / coupang1plist.length);
					e.price1pmiddle = this.middlelevel(coupang1plist.map(ele => ele.price));

					e.pricen1phigh = naver1p.reduce((pv, cv) => { return pv > cv.price ? pv : cv.price }, 0);
					e.pricen1plow = naver1p.reduce((pv, cv) => { return pv < cv.price ? pv : cv.price }, 100000000);
					e.pricen1p = Math.round((naver1p.reduce((pv, cv) => { return pv + cv.price }, 0)) / naver1p.length);
					e.pricen1pmiddle = this.middlelevel(naver1p.map(ele => ele.price));
					// e.crate = (e.review1p/e.totalqty).toFixed(2);
					e.n1psalesqtyhigh = naver1p.reduce((pv, cv) => { return pv > cv.long ? pv : cv.long }, 0);
					e.n1psalesqtylow = naver1p.reduce((pv, cv) => { return pv < cv.long ? pv : cv.long }, 100000000);
					e.n1psalesqty = Math.round((naver1p.reduce((pv, cv) => { return pv + cv.long }, 0)) / naver1p.length);
					e.n1psalesqtymiddle = this.middlelevel(naver1p.map(ele => ele.long));

					e.n1psaleshigh = naver1p.reduce((pv, cv) => { return pv > cv.long * cv.price ? pv : cv.long * cv.price }, 0);
					e.n1psaleslow = naver1p.reduce((pv, cv) => { return pv < cv.long * cv.price ? pv : cv.long * cv.price }, 100000000);
					e.n1psales = Math.round((naver1p.reduce((pv, cv) => { return pv + cv.long * cv.price }, 0)) / naver1p.length);
					e.n1psalesmiddle = this.middlelevel(naver1p.map(ele => ele.long * ele.price));

				}
			})
			setTimeout(() => {
				this.loadingtext = '키워드 별 CPC단가 분석 중';
				this.loadingrate = '';
				this.showspinner = false;
				this.showlist = true;
			}, 1000)


		},
		async sleep(ms) {
			return new Promise((r) => setTimeout(r, ms));
		},
		async importresults(arr) {
			await this.sleep(1000);
			this.loadingtext = '키워드 별 CPC단가 분석 중';
			this.loadingrate = '';
			this.showspinner = true;
			// this.showlist = false;
			window.postMessage({ greeting: "keywordanalysis", data: arr, auth: this.auth }, "*",)
			// // this.waitresult = false;
			// for(var i=0;i<this.rowlines.length;i++){
			// 	var e = this.rowlines[i];
			// 	await this.sleep(1000)
			// 	if(e.targetKeyword || e.productName || e.itemId || e.productId || e.vendorItemId){
			// 		e.showspinner = true;
			// 		e.rank = [];
			// 		e.adqty = '';
			// 		e.adplace = '';
			// 		e.productqty = '';
			// 		e.rocketqty = '';
			// 		e.totalrank = [];
			// 		var data = {
			// 			targetKeyword : e.targetKeyword,
			// 			productName : e.productName,
			// 			itemId : e.itemId,
			// 			productId : e.productId,
			// 			vendorItemId : e.vendorItemId,
			// 			index : i,
			// 			fullsearch : false,
			// 		}
			// 		// console.log(data)
			// 		window.postMessage({greeting: "coupangrank",data:data},"*",)
			// 		// this.waitresult = true;
			// 	}
			// }
			// // this.waitresult = false;
		},
		changelines() {
			this.rowlines = [];
			for (var i = 0; i < this.addlines; i++) {
				this.rowlines.push({ targetKeyword: '', productName: '', itemId: '', productId: '', vendorItemId: '', rank: [], adqty: '', adplace: '', productqty: '', rocketqty: '', showspinner: false, totalrank: [] })
			}
		},
		resetitem(i) {
			this.rowlines[i].targetKeyword = '';
			this.rowlines[i].productName = '';
			this.rowlines[i].itemId = '';
			this.rowlines[i].productId = '';
			this.rowlines[i].rank = [];
			this.rowlines[i].adqty = '';
			this.rowlines[i].adplace = '';
			this.rowlines[i].productqty = '';
			this.rowlines[i].rocketqty = '';
			this.rowlines[i].showspinner = false;
			this.rowlines[i].totalrank = [];
		},
		deleteitem(i) {
			this.rowlines = this.rowlines.slice(0, i).concat(this.rowlines.slice(i + 1))
			if (this.rowlines.length == 0) {
				this.showlist = false;
			}
			this.addlines--
		},
		async getNaverKeywordSearchVolume(keywords) {
			try {
				console.log('네이버 검색광고 API 요청 키워드 총 개수:', keywords.length);

				// 네이버 검색광고 API 컬럼 추가 (첫 번째 배치 처리 전에만 실행)
				if (!this.headers.find(f => f.value == '키워드트렌드지난달네이버')) {
					console.log('네이버 컬럼 추가 시작');
					// 검색트렌드지난달 컬럼 앞에 삽입
					const searchTrendIndex = this.headers.findIndex(f => f.value == '검색트렌드지난달');
					console.log('검색트렌드지난달 인덱스:', searchTrendIndex);
					if (searchTrendIndex > -1) {
						console.log('검색트렌드지난달 앞에 네이버 컬럼 추가');
						this.headers.splice(searchTrendIndex, 0, {
							text: '키워드트렌드\n지난달(네이버)',
							value: '키워드트렌드지난달네이버',
							align: 'center',
							width: 120,
							isSlot: true
						});
					} else {
						// 검색트렌드지난달 컬럼이 없으면 del 컬럼 앞에 추가
						const delIndex = this.headers.findIndex(f => f.value == 'del');
						console.log('del 인덱스:', delIndex);
						if (delIndex > -1) {
							console.log('del 앞에 네이버 컬럼 추가');
							this.headers.splice(delIndex, 0, {
								text: '키워드트렌드\n지난달(네이버)',
								value: '키워드트렌드지난달네이버',
								align: 'center',
								width: 120,
								isSlot: true
							});
						}
					}
					console.log('네이버 컬럼 추가 후 headers:', this.headers);
				}

				// 키워드를 20개씩 배치로 분할 (백엔드 순차 처리 시간 고려)
				const BATCH_SIZE = 20;
				const batches = [];
				for (let i = 0; i < keywords.length; i += BATCH_SIZE) {
					batches.push(keywords.slice(i, i + BATCH_SIZE));
				}

				console.log(`총 ${batches.length}개 배치로 분할 (배치당 최대 ${BATCH_SIZE}개)`);

				// 각 배치를 순차적으로 처리
				for (let batchIndex = 0; batchIndex < batches.length; batchIndex++) {
					const batch = batches[batchIndex];
					console.log(`[배치 ${batchIndex + 1}/${batches.length}] ${batch.length}개 키워드 처리 시작`);

					try {
						const response = await axios.post('/api/naver/getKeywordSearchVolume', {
							keywords: batch
						});

						console.log(`[배치 ${batchIndex + 1}/${batches.length}] API 응답 수신:`, response.data);

						if (response.data.success && response.data.results) {
							// 네이버 검색광고 API 데이터 처리
							for (const naverData of response.data.results) {
								const found = this.keywords.find(
									f => f.keyword.replaceAll(" ", "") == naverData.keyword.replaceAll(" ", "")
								);
								if (found && !naverData.error) {
									// 네이버 월간 검색량 (PC + 모바일)
									const naverMonthlyVolume = (naverData.monthlyPcQcCnt || 0) + (naverData.monthlyMobileQcCnt || 0);
									found.키워드트렌드지난달네이버 = naverMonthlyVolume;
								}
							}

							// 각 배치 처리 후 즉시 IndexedDB에 저장
							await this.saveCurrentGroup();

							// 화면 업데이트를 위해 강제로 리렌더링
							this.$forceUpdate();

							console.log(`[배치 ${batchIndex + 1}/${batches.length}] 처리 완료 및 저장 완료`);
						}
					} catch (error) {
						console.error(`[배치 ${batchIndex + 1}/${batches.length}] API 호출 실패:`, error);
						// 에러가 발생해도 다음 배치 계속 처리
					}

					// 다음 배치 처리 전 짧은 대기 (API Rate Limiting 고려)
					if (batchIndex < batches.length - 1) {
						await new Promise(resolve => setTimeout(resolve, 500));
					}
				}

				console.log('모든 배치 처리 완료');

			} catch (error) {
				console.error('네이버 검색광고 API 호출 실패:', error);
			}
		},
		async search() {
			var collectItems = [];
			if (this.tableSelectedItem.length > 0) {
				if (confirm(this.tableSelectedItem.length + '개의 키워드 데이터를 수집 하시겠습니까?')) {
					collectItems = this.tableSelectedItem
				}
			} else {
				if (confirm('전체 키워드 데이터를 수집 하시겠습니까?')) {
					collectItems = this.keywords;
				}
			}
			if (collectItems.length == 0) {
				alert('수집할 키워드가 없습니다.')
				return
			}
			if (!this.showCoupangMonthlySearch &&
				!this.showCoupangMedianPrice &&
				!this.showCoupangPriceRange &&
				!this.showCoupangOneStarRate &&
				!this.showOptimalCategory &&
				!this.showCoupangAvgPrice &&
				!this.showCoupangMedianSales &&
				!this.showCoupangAvgSales &&
				// !this.showCoupangMedianViews &&
				!this.showCoupangAvgViews &&
				!this.showCoupangRecCPC &&
				!this.showCoupangTopGrowthRate &&
				!this.showCoupangTopRocketRate &&
				!this.showCoupangTopWingRate &&
				// !this.showNaverAvgSales &&
				!this.showSearchTrend
			) {
				alert('수집할 데이터를 선택해주세요')
				return
			}

			// 네이버 검색광고 API 데이터 수집 (Extension과 별도로 독립적으로 요청)
			if (this.showCoupangMonthlySearch) {
				const collectKeywords = collectItems.map(k => k.keyword);
				console.log('네이버 검색광고 API 호출 시작 (독립 요청)');
				this.getNaverKeywordSearchVolume(collectKeywords);
			}

			// Extension으로 쿠팡 데이터 수집 요청
			this.rateLimitAlerted = false;
			this.reviewOffAlerted = false;
			this.salesZeroNotice = '';
			window.postMessage({
				greeting: "getCollectKeywordData",
				keywords: collectItems,
				fastCollect: this.collectMode === 'fast',
				datalabAPI: {
					clientId: this.$store.state.settings[0].clientId ? this.$store.state.settings[0].clientId : '',
					clientSecret: this.$store.state.settings[0].clientSecret ? this.$store.state.settings[0].clientSecret : '',
				},
				data: {
					showCoupangMonthlySearch: this.showCoupangMonthlySearch,
					showCoupangMedianPrice: this.showCoupangMedianPrice,
					showCoupangPriceRange: this.showCoupangPriceRange,
					showCoupangOneStarRate: this.showCoupangOneStarRate,
					showOptimalCategory: this.showOptimalCategory,
					showCoupangAvgPrice: this.showCoupangAvgPrice,
					showCoupangMedianSales: this.showCoupangMedianSales,
					showCoupangAvgSales: this.showCoupangAvgSales,
					// showCoupangMedianViews: this.showCoupangMedianViews,
					showCoupangAvgViews: this.showCoupangAvgViews,
					showCoupangRecCPC: this.showCoupangRecCPC,
					showCoupangTopGrowthRate: this.showCoupangTopGrowthRate,
					showCoupangTopRocketRate: this.showCoupangTopRocketRate,
					showCoupangTopWingRate: this.showCoupangTopWingRate,
					// showNaverAvgSales: this.showNaverAvgSales,
					showSearchTrend: this.showSearchTrend,
				}
			}, "*",)

			this.loadingtext = '키워드 데이터 수집 중';
			this.loadingrate = '';
			this.showspinner = true;
			// this.showlist = false;
		},
		searchresult() {
			this.saleslists = [];
			this.showlist = false;
			var obj = {};
			var d = {};
			var 이전재고 = '';
			var t = {};
			var su = {};
			var 입고수량 = 0;
			if (this.$store.state.sales.length > 0) {
				this.$store.state.sales.sort(function (a, b) {
					if (a.date < b.date) {
						return -1;
					}
					if (a.date > b.date) {
						return 1;
					}
					return 0;
				})
				console.log(this.$store.state.sales)
				console.log(this.$store.state.supply)
				this.$store.state.productdb.forEach(e => {
					if (this.$store.state.sales.filter(ele => ele.판매세부내역.find(element => element.sk == e["SKU ID"])).length == this.$store.state.sales.length) {
						obj = {
							썸네일: e.썸네일,
							판매상품명: e.판매상품명,
							SKUID: e["SKU ID"],
							바코드: e.바코드,
							발주가능상태: e.발주가능상태,
							재고: 0,
							판매: 0,
							입고: 0,
							판매가: 0,
							판매매출: 0,
							공급매출: 0,
							리뷰수: 0,
							리뷰평점: 0,
							판매링크: e.판매링크,
							판매세부내역: []
						}
						if (this.$store.state.sales.length > 1) {
							this.$store.state.sales.forEach(ele => {
								t = ele.판매세부내역.find(element => element.sk == e["SKU ID"]);
								//console.log(t)
								if (this.$store.state.supply.find(element => element.importdate == ele.date)) {
									su = this.$store.state.supply.find(element => element.importdate == ele.date);
									//console.log(su)
									if (su.importlist.filter(element => element.sku번호.toString() == t.sk.toString()).length > 0) {
										입고수량 = su.importlist.filter(element => element.sku번호.toString() == t.sk.toString()).reduce((pv, rv) => { return pv + parseInt(rv.수량) }, 0)
									} else {
										입고수량 = 0;
									}
								} else {
									입고수량 = 0
								}
								if (이전재고 == '') {
									이전재고 = t.s ? t.s : 0;
								}
								d = {
									date: ele.date,
									발주가능상태: e.발주가능상태,
									재고: t.s + 입고수량 ? t.s + 입고수량 : 0,
									판매: 0,
									입고: 입고수량 ? 입고수량 : 0,
									판매가: t.p ? t.p : 0,
									판매매출: 0,
									공급매출: 0,
									리뷰수: t.rq ? t.rq : 0,
									리뷰평점: t.rp ? t.rp : 0,
									판매링크: e.판매링크,
								}
								obj.판매세부내역.push(this.deepClone(d))
								obj.재고 = t.s ? t.s : 0;
								obj.판매가 = t.p ? t.p : 0;
								obj.리뷰수 = t.rq ? t.rq : 0;
								obj.리뷰평점 = t.rp ? t.rp : 0;
								obj.입고 += d.입고 ? d.입고 : 0;
								이전재고 = d.재고 ? d.재고 : 0;
							})
							var salesqty = 0
							for (var j = 1; j < obj.판매세부내역.length; j++) {
								salesqty = obj.판매세부내역[j - 1].재고 - obj.판매세부내역[j].재고 + obj.판매세부내역[j].입고 ? obj.판매세부내역[j - 1].재고 - obj.판매세부내역[j].재고 + obj.판매세부내역[j].입고 : 0;
								obj.판매세부내역[j].판매 = salesqty ? salesqty : 0;
								obj.판매 += salesqty ? salesqty : 0;
								obj.판매세부내역[j].판매매출 = salesqty * obj.판매세부내역[j].판매가 ? salesqty * obj.판매세부내역[j].판매가 : 0;
								obj.판매매출 += salesqty * obj.판매세부내역[j].판매가 ? salesqty * obj.판매세부내역[j].판매가 : 0;
								obj.판매세부내역[j].공급매출 = salesqty * e.매입가 ? salesqty * e.매입가 : 0;
								obj.공급매출 += salesqty * e.매입가 ? salesqty * e.매입가 : 0;
							}
						} else {
							this.$store.state.sales.forEach(ele => {
								t = ele.판매세부내역.find(element => element.sk == e["SKU ID"]);
								// console.log(t)
								if (this.$store.state.supply.find(element => element.importdate == ele.date)) {
									su = this.$store.state.supply.find(element => element.importdate == ele.date);
									// console.log(su)
									if (su.importlist.find(element => element.sku번호.toString() == t.sk.toString())) {
										입고수량 = parseInt(su.importlist.find(element => element.sku번호.toString() == t.sk.toString()).수량);
									} else {
										입고수량 = 0;
									}
								} else {
									입고수량 = 0
								}
								d = {
									date: ele.date,
									발주가능상태: e.발주가능상태,
									재고: t.s ? t.s : 0,
									판매: 0,
									입고: 입고수량 ? 입고수량 : 0,
									판매가: t.p ? t.p : 0,
									판매매출: 0,
									공급매출: 0,
									리뷰수: t.rq ? t.rq : 0,
									리뷰평점: t.rp ? t.rp : 0,
									판매링크: e.판매링크,
								}
								obj.판매세부내역.push(this.deepClone(d))
								obj.재고 = t.s ? t.s : 0;
								obj.판매가 = t.p ? t.p : 0;
								obj.리뷰수 = t.rq ? t.rq : 0;
								obj.리뷰평점 = t.rp ? t.rp : 0;
								obj.판매 = 0;
								obj.입고 += d.입고 ? d.입고 : 0;
								obj.판매매출 = 0;
								obj.공급매출 = 0;
								setTimeout(() => { 이전재고 = d.재고 ? d.재고 : 0 }, 1)
							})
						}
						this.saleslists.push(this.deepClone(obj))
						this.saleslistsinit.push(this.deepClone(obj))
					}
				})

				this.salescnt = this.saleslists.reduce((pv, rv) => { return pv + rv.판매 }, 0)
				this.importcnt = this.saleslists.reduce((pv, rv) => { return pv + rv.입고 }, 0)
				this.salesamount = this.saleslists.reduce((pv, rv) => { return pv + rv.판매매출 }, 0)
				this.supplyamount = this.saleslists.reduce((pv, rv) => { return pv + rv.공급매출 }, 0)
				this.noreview = this.saleslists.filter(e => e.리뷰수 == 0).length;
				this.productqty = this.saleslists.length;
				this.nostock = this.saleslists.filter(e => e.재고 == 0).length;

				if (this.saleslists.length == 0) {
					alert("판매현황이 없습니다.")
					this.showspinner = false;
					return
				}
				setTimeout(() => {
					this.showlist = true;
					this.showspinner = false;
				}, 1);
			} else {
				alert("판매현황이 없습니다.")
				this.showspinner = false;
				return
			}

		},
		deepClone(obj) {
			if (obj === null || typeof obj !== "object") {
				return obj
			}

			const result = Array.isArray(obj) ? [] : {}

			for (let key of Object.keys(obj)) {
				result[key] = this.deepClone(obj[key])
			}

			return result
		},
		todate(date) {
			var today = new Date(date);
			today.setHours(today.getHours() + 9);
			return today.toISOString().replace('T', ' ').substring(0, 19);
		},
		timestamp(date) {
			//inputdate = "yyyy-mm-dd"
			return new Date(date).getTime()
		},
		getTodaywith() {
			var date = new Date();
			var year = date.getFullYear();
			var month = ("0" + (1 + date.getMonth())).slice(-2);
			var day = ("0" + date.getDate()).slice(-2);

			return year + "-" + month + "-" + day;
		},
		download() {
			function getToday() {
				var date = new Date();
				var year = date.getFullYear();
				var month = ("0" + (1 + date.getMonth())).slice(-2);
				var day = ("0" + date.getDate()).slice(-2);

				return year + month + day;
			}
			var arr = [];
			this.rowlines.forEach(e => {
				arr.push({
					키워드: e.targetKeyword,
					쿠팡1p윙비율: e.wingrate,
					쿠팡1p윙제품수: e.wing1p,
					쿠팡1p로켓제품수: e.rocket1p,
					쿠팡1p그로스제품수: e.growth1p,
					쿠팡광고비율: e.adrate,
					쿠팡광고상품수: e.adqty,
					쿠팡광고구좌수: e.adplace,
					쿠팡광고CPC단가_추천: e.cpc,
					쿠팡광고CPC단가_최대: e.cpchigh,
					쿠팡광고CPC단가_최저: e.cpclow,
					쿠팡로켓비율: e.rocketrate,
					쿠팡로켓상품수: e.rocketqty,
					쿠팡전체상품수: e.totalqty,

					쿠팡1p리뷰수_평균: e.review1p,
					쿠팡1p리뷰수_최대: e.review1phigh,
					쿠팡1p리뷰수_최저: e.review1plow,
					쿠팡1p리뷰수_중간: e.review1pmiddle,

					쿠팡1p판매가_평균: e.price1p,
					쿠팡1p판매가_최대: e.price1phigh,
					쿠팡1p판매가_최저: e.price1plow,
					쿠팡1p판매가_중간: e.price1pmiddle,

					네이버1p판매가_평균: e.pricen1p,
					네이버1p판매가_최대: e.pricen1phigh,
					네이버1p판매가_최저: e.pricen1plow,
					네이버1p판매가_중간: e.pricen1pmiddle,

					네이버1p월판매수량_평균: e.n1psalesqty,
					네이버1p월판매수량_최대: e.n1psalesqtyhigh,
					네이버1p월판매수량_최저: e.n1psalesqtylow,
					네이버1p월판매수량_중간: e.n1psalesqtymiddle,
					네이버1p월매출_평균: e.n1psales,
					네이버1p월매출_최대: e.n1psaleshigh,
					네이버1p월매출_최저: e.n1psaleslow,
					네이버1p월매출_중간: e.n1psalesmiddle,
				})
			})
			const workBook = XLSX.utils.book_new()
			const workSheet1 = XLSX.utils.json_to_sheet(arr)
			XLSX.utils.book_append_sheet(workBook, workSheet1, '키워드분석')
			XLSX.writeFile(workBook, '키워드분석' + '_' + getToday() + '.xlsx')
		},
		settinglist() {

		}
	}

}
</script>

<style scoped></style>